<template>
  <div>
  <div class="AppointmentList CommonContentSingle-gray">
    <el-drawer :title="$t('original.languages307')" :visible.sync="showViewDetails">
      <el-descriptions :title="$t('original.languages308')" style="padding-left: 24px; padding-top: 10px;" :column="1">
        <el-descriptions-item :label="$t('original.languages207')">
          {{ detailsdata.RealName }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('original.phone')">
          {{ detailsdata.Phone }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('original.languages147')">
          <span :class="detailsdata.Status == '已预约' ? 'status_blue' : detailsdata.Status == '自主取消' ||  detailsdata.Status == '心理中心取消' ? 'status_red' : detailsdata.Status == '未来访' ? 'status_orange' : 'status_green'">
            {{ detailsdata.Status }}
          </span>
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages216')" v-if="detailsdata.Status == '自主取消' || detailsdata.Status == '心理中心取消'">
          {{ detailsdata.CancelCause }}
        </el-descriptions-item>

        <el-descriptions-item label="取消时间" v-if="detailsdata.Status == '自主取消' || detailsdata.Status == '心理中心取消'">
          {{ detailsdata.CancelTime }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages208')">
          {{ detailsdata.ConsultTheme }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages209')">
          {{ detailsdata.ConsultCntIntroduce }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages272')">
          <!-- {{ ConsultPaperTime }} -->
          {{ detailsdata.ConsultTime }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages226')">
          {{ detailsdata.ZXDZ }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages212')">
          {{ detailsdata.ConsultType}}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages310')">
          {{ detailsdata.ResidueCount }}
        </el-descriptions-item>
       
        <el-descriptions-item :label="$t('original.languages311')">
          {{ detailsdata.Yuyue }}
        </el-descriptions-item>

      </el-descriptions>

      <el-descriptions :title="$t('original.languages312')" style="padding-left: 24px; padding-top: 10px;" :column="1">

        <el-descriptions-item :label="$t('original.languages315')">
          {{ detailsdata.IsHurt == 1 ? $t('original.languages162'): detailsdata.IsHurt == -1 ? $t('original.languages522') :$t('original.languages163') }}
        </el-descriptions-item>

        <el-descriptions-item v-if="detailsdata.IsHurt == 1" :label="'1.1、' + $t('original.languages523')">
          {{ detailsdata.HurtDetail}}
        </el-descriptions-item>

        <el-descriptions-item :label="'2、'+ $t('original.languages524')">
          {{ detailsdata.IsAttack == 1 ? $t('original.languages162') : detailsdata.IsAttack == -1 ? $t('original.languages522') : $t('original.languages163') }}
        </el-descriptions-item>

        <el-descriptions-item v-if="detailsdata.IsAttack == 1" :label="'2.1、' + $t('original.languages527')">
          {{ detailsdata.AttackDetail }}
        </el-descriptions-item>

        <el-descriptions-item :label="'3、' + $t('original.languages528')">
          {{ detailsdata.IsSpiritCure == 1 ?  $t('original.languages162') : detailsdata.IsSpiritCure == -1 ? $t('original.languages522') : $t('original.languages163') }}
        </el-descriptions-item>

        <el-descriptions-item v-if="detailsdata.IsSpiritCure == 1" :label="'3.1、' +  $t('original.languages525')">
          {{ detailsdata.SpiritCureDetail }}
        </el-descriptions-item>

        <el-descriptions-item v-if="detailsdata.IsSpiritCure == 1" :label="'3.2、' + $t('original.languages526')">
          {{ detailsdata.PsychotropicDrug  }}
        </el-descriptions-item>

      </el-descriptions>

      <el-descriptions :title="$t('original.languages529')" style="padding-left: 24px; padding-top: 10px;" :column="1">

        <el-descriptions-item label="SAS焦虑自评量表">
          {{ detailsdata.SASResult }}分，
          时间：
          {{ detailsdata.SASDateTime }}

          <span v-if="detailsdata.SASPaperResultID" @click="Gourl(detailsdata.SASPaperResultID)" style="color: rgba(29, 154, 255, 1); cursor: pointer;margin-left:10px">
            {{$t('original.languages174')}}
          </span>

        </el-descriptions-item>

        <el-descriptions-item :label="'SDS' + $t('original.languages530')">
          {{ detailsdata.SDSResult }}分，
          时间：
          {{ detailsdata.SDSDateTime }}

          <span v-if="detailsdata.SDSPaperResultID" @click="Gourl(detailsdata.SDSPaperResultID)"
            style="color: rgba(29, 154, 255, 1); cursor: pointer;margin-left:10px">
            {{$t('original.languages174')}}
          </span>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions :title="$t('original.languages531')" style="padding-left: 24px; padding-top: 10px;" :column="1">

        <el-descriptions-item :label="$t('original.languages531')">
          {{ detailsdata.UserName }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages79')">
          {{ detailsdata.UserID }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.gender')">
          {{ detailsdata.Sex }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.Date_of_birth')">
          {{ detailsdata.Birthday }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages359')">
          {{ detailsdata.MarriageState }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.phone')">
          {{ detailsdata.Phone }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.languages532')">
          {{ detailsdata.Email }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.Id_number')">
          {{ detailsdata.IDCard }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.grade')">
            {{ detailsdata.EntryDate }}
          </el-descriptions-item>

             <!-- <el-descriptions-item label="所在年级">
            {{ detailsdata.EntryDate }}
          </el-descriptions-item> -->


        <el-descriptions-item :label="$t('original.Name_of_Company2')">
          {{ detailsdata.TrainName }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.Name_of_Company3')">
          {{ detailsdata.TestName }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('original.Name_of_Company')">
          {{ detailsdata.DeptName }}
        </el-descriptions-item>

      </el-descriptions>


      <el-descriptions :title="$t('original.languages360')" style="padding-left: 24px; padding-top: 10px; margin-bottom: 0px;" :column="1">

          <el-descriptions-item :label="'1、'+ $t('original.languages533')">
            {{ detailsdata.EmergentPerson}}
          </el-descriptions-item>

          <el-descriptions-item :label="'2、' + $t('original.phone')">
            {{ detailsdata.EmergentMobile }}
          </el-descriptions-item>

          <el-descriptions-item :label="'3、' + $t('original.languages534')">
            {{ detailsdata.EmergentRelation }}
          </el-descriptions-item>

        </el-descriptions>

      <el-descriptions :title="$t('original.languages535')" style="padding-left: 24px; padding-top: 10px; margin-bottom: 50px;" :column="1">

        <el-descriptions-item :label="'1、' + $t('original.languages536')">

          {{ detailsdata.OnlySon == '1' ? $t('original.languages162') :detailsdata.OnlySon == -1 ? $t('original.languages522') : $t('original.languages163') }}
        </el-descriptions-item>

        <el-descriptions-item v-if="detailsdata.OnlySon == '0'" :label="'1.1、'+ $t('original.languages537')">
          {{ detailsdata.BirthOrder }}
        </el-descriptions-item>
        
        <el-descriptions-item :label="'2、' + $t('original.languages538')">
          {{ detailsdata.HomeType }}
        </el-descriptions-item>

        <!-- <el-descriptions-item v-if="detailsdata.HomeType == 1" label="2、家庭所在地类型">
          乡镇
        </el-descriptions-item>

        <el-descriptions-item  v-if="detailsdata.HomeType == 0"  label="2、家庭所在地类型" >
          城市
        </el-descriptions-item>

        <el-descriptions-item v-if="detailsdata.HomeType == 2" label="2、家庭所在地类型">
          农村
        </el-descriptions-item> -->

        <el-descriptions-item :label="'3、' + $t('original.languages539')">
          {{ detailsdata.IsSubsidy == 1 ?  $t('original.languages162')  : detailsdata.IsSubsidy == -1 ? $t('original.languages522') :  $t('original.languages163') }}
        </el-descriptions-item>

        <el-descriptions-item :label="'4、' + $t('original.languages540')">
          {{ detailsdata.FatherDegree }}
        </el-descriptions-item>

        <el-descriptions-item :label="'5、'+ $t('original.languages541')">
          {{ detailsdata.MatherDegree }}
        </el-descriptions-item>

        <el-descriptions-item :label="'6、' + $t('original.languages542')">
          {{ detailsdata.FamilyStatus }}
        </el-descriptions-item>

        <el-descriptions-item :label="'7、' + $t('original.languages543')">
          {{ detailsdata.EconStatus }}
        </el-descriptions-item>

        <el-descriptions-item :label="'8、' + $t('original.languages544')">
          {{ detailsdata.LikeLevel }}
        </el-descriptions-item>

        <el-descriptions-item :label="'9、' + $t('original.languages545')">
          {{ detailsdata.YiYU }}
        </el-descriptions-item>

      </el-descriptions>

    </el-drawer>
    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);min-height: 150px;height: auto;">
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline" style="background: rgba(255, 255, 255, 1);padding: 10px;height: 42px;">

          <el-form-item :label="$t('original.languages110')">
            <el-input :placeholder="$t('original.languages111')" v-model.trim="ruleForm.UserInfo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.languages546')">
            <el-input :placeholder="$t('original.languages111')" v-model="ruleForm.CounselorInfo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('original.languages445')" prop="campus">
            <el-select v-model="ruleForm.Campus" :placeholder="$t('original.languages3')">
              <el-option v-for="item in campus_list" :key="item.dicKey" :label="item.cDicValue"
                :value="item.dicKey">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('original.languages547')">
            <el-date-picker v-model="ruleForm.UserTime" type="daterange" align="right" value-format="yyyy-MM-dd" unlink-panels :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>

          <el-form-item label="预约时间">
            <el-date-picker v-model="ruleForm.AppointmentTime" type="daterange" align="right" value-format="yyyy-MM-dd" :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('original.languages212')">
            <el-radio-group v-model="ruleForm.ConsultType">
              <el-radio label="0">{{$t('original.languages314')}}</el-radio>
              <el-radio label="1">{{$t('original.languages548')}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-button type="primary" @click="onSelect()" style="margin-left: 20px;">{{$t('original.languages470')}}</el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px; margin-left: 10px;">
            {{$t('original.reset')}}
          </el-button>

        </el-form>
      </el-header>

      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1);">
        <!-- <el-button type="primary" v-if="entity == '管理员'" style="margin-bottom: 20px;" @click="WPPdialogVisible3 = true">
          添加预约
        </el-button> -->

        <el-table class="Page" :data="AppointList" style="width: 100%;" v-loading="IsLoading"
          element-loading-background="rgba(255,255,255,1)" :element-loading-text="$t('original.languages22')"
          element-loading-spinner="el-icon-loading" @filter-change="filterChange"   :row-class-name="tableRowClassName">
          <el-table-column :label="$t('original.The_serial_number')" width="60px" align="left">
            <template slot-scope="scope" center>
              <!-- {{ scope.$index + 1 }} -->
              {{ (Number(currentPage1)  - 1) * 10 + Number(scope.$index)  + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="UserID" :label="$t('original.languages549')" min-width="8%"></el-table-column>
          <el-table-column prop="UserName" :label="$t('original.name')" min-width="8%"></el-table-column>
          <el-table-column prop="ConUserName" label="咨询师" min-width="10%"></el-table-column>
          <el-table-column prop="AppointmentTime" label="预约时间" min-width="15%"></el-table-column>
          <el-table-column prop="ConsultTime" label="咨询时间" min-width="15%"></el-table-column>
          <el-table-column prop="Campus" label="校区" min-width="15%"></el-table-column>
          <el-table-column prop="ConAddressName" label="咨询地点" min-width="20%"></el-table-column>
          <el-table-column prop="ConsultType" label="咨询方式" min-width="8%"></el-table-column>
          <el-table-column prop="ReserveSource" label="预约来源" min-width="8%"></el-table-column>
          <!-- 1按时0超时空没咨询 -->
          <!-- <el-table-column prop="IsInTime" label="记录延期" min-width="10%"></el-table-column> -->
          <el-table-column label="记录延期" min-width="10%" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.IsInTime == '1'" style="color: rgb(61, 255, 165);">
                按时填写
              </span>
              <span v-if="scope.row.IsInTime == '0'" style="color: red;">
                超时填写
              </span>
              <span v-if="scope.row.IsInTime == ''">
                -
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="IsLongConsult" label="长期咨询" min-width="8%">
            <template v-slot="scope">
              {{scope.row.IsLongConsult?'是':'否'}}
            </template>
          </el-table-column>

          <el-table-column prop="tag" label="咨询状态" width="150" column-key="filterTag" :filters="[
            { text: '未来访', value: '未来访' },
            { text: '已预约', value: '已预约' },
            { text: '自主取消', value: '自主取消' },
            { text: '心理中心取消', value: '心理中心取消' },
            { text: '已来访', value: '已来访' },
          ]">
            <template slot-scope="scope">
              <span :class="scope.row.Zt == 1 ? 'status_blue' : scope.row.Zt == 2 || scope.row.Zt == 3 ? 'status_red' : scope.row.Zt == 4 ? 'status_orange' : 'status_green'">
                {{ scope.row.Status }}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="ResidueCount" label="剩余次数" min-width="8%"></el-table-column>
          <el-table-column prop="OldFlag" label="老记录" min-width="8%">
            <template slot-scope="scope">
              <span v-if="scope.row.OldFlag == 1">有</span>
              <span v-else-if="scope.row.OldFlag == 0">无</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="25%" align="center">
            <template slot-scope="scope">
              <span @click="ViewDetails(scope.row)" class="table_btn"> 预约详情</span>
              <!-- <span v-if="scope.row.ReportStatus=='18'" @click="$refs.childdetail.Detail(scope.row,0)" class="table_btn"> 修改</span> -->
              <span v-if="scope.row.IsCanAnswer && !pdroleid(1057)" @click="Fillin(scope.$index, scope.row)" class="table_btn">填写记录 </span>
              <span v-if="scope.row.IsReadAnswer" @click="wlooks(scope.$index, scope.row)" class="table_btn"> 查看记录</span>
              <span v-if="scope.row.Status == '已预约' && scope.row.IsNoCome" class="table_btn" @click="weilaifang((scope.$index, scope.row))"> 未来访 </span>
              
              <span v-if="pdroleid(1058) && scope.row.canComment" class="table_btn" @click="aaad(scope.row,1)">评价</span>
              <span v-if="(pdroleid(1057) || pdroleid(1070) || pdroleid(1069) || pdroleid(1068)) && scope.row.canComment == false" class="table_btn" @click="aaad(scope.row,2)">查看评价</span>

              <span v-if="scope.row.Status=='已来访（准时）'|| scope.row.Status=='已来访（迟到）'" class="table_btn"  @click="Visited((scope.row))"> 危机上报</span>

              <span class="w" v-if="scope.row.OldFlag == 1 && scope.row.ConsultRecord" @click="hxsi(scope.row,1)">咨询报告</span>
              <span class="w" v-if="scope.row.OldFlag == 1 && scope.row.CrisisRecord" @click="hxsi(scope.row,2)">上报报告</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="AppointList.length > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts">
          </el-pagination>
        </div>
      </el-main>
    </el-container>

    <el-dialog title="预约详情" :visible.sync="dialogVisible" width="50%">
      <div class="app-parent" v-loading="IsDialogLoading" element-loading-background="rgba(255,255,255,1)"
        element-loading-spinner="el-icon-loading">
        <div class="app-block">
          <h4>个人信息</h4>
          <ul class="app-ul">
            <li v-for="(value, key, index) in CurrentItem.Basic" :key="index">
              <span>{{ key }}</span>:<span>{{ value }}</span>
            </li>
          </ul>
        </div>
        <div class="app-block">
          <h4>家庭情况</h4>
          <ul class="app-ul">
            <li v-for="(value, key, index) in CurrentItem.Family" :key="index">
              <span>{{ key }}</span>:<span>{{ value }}</span>
            </li>
          </ul>
        </div>
        <div class="app-block">
          <h4>咨询问卷</h4>
          <ul class="app-ul">
            <li>
              <span class="app-paper-item">SAS焦虑自评量表测试结果:</span>
              <span class="app-paper-res" :style="{
                color:
                  CurrentItem.PaperTestResult.SASScore >= 70
                    ? '#cf0707'
                    : '#07cf94',
              }">
                {{ CurrentItem.PaperTestResult.SASScore }}
              </span>
              <span class="app-paper-detail" @click="CheckPaperDetail(CurrentItem.PaperTestResult.SASResultID)">
                查看详情
              </span>
            </li>
            <li>
              <span class="app-paper-item">SDS抑郁自评量表测试结果:</span>
              <span class="app-paper-res" :style="{
                color:
                  CurrentItem.PaperTestResult.SDSScore >= 70
                    ? '#cf0707'
                    : '#07cf94',
              }">
                {{ CurrentItem.PaperTestResult.SDSScore }}
              </span>
              <span class="app-paper-detail" @click="CheckPaperDetail(CurrentItem.PaperTestResult.SDSResultID)">
                查看详情
              </span>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="WPPdialogVisible" width="80%" :before-close="handleClose">
      <div class="filein">
        <div class="filein-top">
          <p class="filein-top-p1">
            <span>
              {{ wonedata.UserName }}(<span>来访者</span>)
              <i>{{ wonedata.Status }}</i>
            </span>
          </p>
          <el-button type="primary" @click="Query_record()">查询记录</el-button>

          <el-form style="margin:0 20px">
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">咨询方式：{{ wonedata.ConsultType }}</el-col>
                <el-col :span="6">咨询地点：{{ wonedata.Address}}</el-col>
                <el-col :span="6">联系方式：{{ wonedata.Phone}}</el-col>
                <el-col :span="6">预约时间：{{ wonedata.AppointmentTime}}</el-col>
              </el-row>
            </el-form-item>
            <el-form-item style="margin: 0"> {{wonedata.MarriageState}}
              <el-row>
                
                <el-col v-if="wonedata.MarriageState == 0" :span="6">婚姻状态：未婚</el-col>
                <el-col v-if="wonedata.MarriageState == 1" :span="6">婚姻状态：已婚</el-col>
                <el-col v-if="wonedata.MarriageState == -1" :span="6">婚姻状态：未知</el-col>

                <el-col :span="6">性别：{{ wonedata.Sex }}</el-col>
                <el-col :span="6">年龄：{{ wonedata.Age }}</el-col>
                <el-col :span="6">咨询时间：{{ wonedata.ConsultTime}}</el-col>
              </el-row>
            </el-form-item>
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">剩余次数：{{wonedata.Balance}}</el-col>
                <el-col :span="6">所属院系所：{{wonedata.DeptName}}</el-col>
                <el-col :span="6">目前年级：{{wonedata.EntryDate}}</el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        <div class="filein-button">
          <h2>个人情况</h2>
          <h3>知情同意</h3>
          <el-form :inline="true" :model="from" ref="from" label-width="100px" class="demo-ruleForm">
            <el-form-item disabled="true" label-width="260px" label="保密原则告知和解释（书面和口头）" prop="AnswerName1">
              <el-radio-group v-model="from.AnswerName1">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="知情同意讨论（书面和口头）" prop="AnswerName2">
              <el-radio-group v-model="from.AnswerName2">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="预约状态" prop="AnswerName1">
              <el-radio-group v-model="from.Status">
                <el-radio label="4">未来访</el-radio>
                <el-radio label="5">已来访（准时）</el-radio>
                <el-radio label="6">已来访（迟到）</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%; heighe: 54px;">
              <el-input style="margin-left: 0px;" maxlength="400" show-word-limit type="textarea"
                v-model="from.AnswerName3"></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>来访者问题主诉</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%;">
              <p style="margin-left: 20px;">
                来访者：
                <span>{{ wonedata.UserName }}</span>
                ,年龄：
                <span>{{ wonedata.Age }}</span>
                ,于
                <span>
                  <el-input class="qxs1" v-model="from.Riqi"></el-input>
                </span>
                因
                <el-input class="qxs1" v-model="from.AnswerName4"></el-input>
                来寻求咨询帮助。
                
                <!-- ，希望咨询师就
                <el-input class="qxs1" v-model="from.AnswerName5"></el-input>
                的情况提供帮助。 -->
              </p>
            </el-form-item>

            <el-form-item class="bagtit" style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>相关健康史<span>（重大疾病史）</span></p>
              </div>
            </el-form-item>

            <el-form-item label-width="124px" class="bvds" style="margin-left: 20px;">
              <el-input maxlength="400" show-word-limit type="textarea" v-model="from.AnswerName7"></el-input>
            </el-form-item>

            <el-form-item style="width:100%;border: none!important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>个人成长史</p>
              </div>
            </el-form-item>

            <el-form-item style="width:100%;border:none!important;" label-width="40px">
              <h2 style="font-size: 14px;">创伤史</h2>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="重大丧失">
              <el-radio-group v-model="from.AnswerName8">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName8 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入重大丧失说明" show-word-limit type="textarea" v-model="from.AnswerName8Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="暴力侵害">
              <el-radio-group v-model="from.AnswerName9">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName9 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入暴力侵害说明" show-word-limit type="textarea" v-model="from.AnswerName9Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="性侵害">
              <el-radio-group v-model="from.AnswerName10">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName10 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入性侵害说明" show-word-limit type="textarea" v-model="from.AnswerName10Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="被忽视" prop="UserID">
              <el-radio-group v-model="from.AnswerName11">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName11 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入被忽视说明" show-word-limit type="textarea" v-model="from.AnswerName11Detail"></el-input>
            </el-form-item>

            <!-- <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <el-input maxlength="400" show-word-limit type="textarea" v-model="from.AnswerName12"></el-input>
            </el-form-item> -->
            
            <br>

            <el-form-item disabled="true" label-width="120px" label="精神病史" prop="UserID">
              <el-radio-group v-model="from.AnswerName13">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName13 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入精神病史说明" show-word-limit type="textarea" v-model="from.AnswerName13Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="自杀自伤" prop="UserID">
              <el-radio-group v-model="from.AnswerName14">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName14 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入自杀自伤说明" show-word-limit type="textarea" v-model="from.AnswerName14Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="暴力攻击倾向" prop="UserID">
              <el-radio-group v-model="from.AnswerName16">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName16 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入暴力攻击倾向说明" show-word-limit type="textarea" v-model="from.AnswerName16Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="酒精滥用" prop="UserID">
              <el-radio-group v-model="from.AnswerName17">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName17 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入酒精滥用说明" show-word-limit type="textarea" v-model="from.AnswerName17Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="120px" label="物质滥用" prop="UserID" style="width: 100%;">
              <el-radio-group v-model="from.AnswerName18">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName18 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入物质滥用说明" show-word-limit type="textarea" v-model="from.AnswerName18Detail"></el-input>
            </el-form-item>
<!-- 
            <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <el-input maxlength="400" show-word-limit type="textarea" v-model="from.AnswerName19"></el-input>
            </el-form-item> -->


            <el-form-item disabled="true" label-width="120px" label="家族史" prop="UserID" style="width: 100%;">
              <el-radio-group v-model="from.AnswerName13A">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

<!-- 父亲 母亲 祖父 外祖父 祖母 外祖母 其他 -->
            <el-form-item v-if="from.AnswerName13A == '0'" class="hiucs" label="父亲" label-width="80px" style="width: 100%;">
              <el-input maxlength="200" show-word-limit type="textarea" v-model="from.AnswerName13A_1"></el-input>
            </el-form-item>
            
            <el-form-item v-if="from.AnswerName13A == '0'" class="hiucs" label="母亲" label-width="80px" style="width: 100%;">
              <el-input maxlength="200" show-word-limit type="textarea" v-model="from.AnswerName13A_2"></el-input>
            </el-form-item>

            <el-form-item v-if="from.AnswerName13A == '0'" class="hiucs" label="祖父" label-width="80px" style="width: 100%;">
              <el-input maxlength="200" show-word-limit type="textarea" v-model="from.AnswerName13A_3"></el-input>
            </el-form-item>

            <el-form-item v-if="from.AnswerName13A == '0'" class="hiucs" label="祖母" label-width="80px" style="width: 100%;">
              <el-input maxlength="200" show-word-limit type="textarea" v-model="from.AnswerName13A_5"></el-input>
            </el-form-item>

            <el-form-item v-if="from.AnswerName13A == '0'" class="hiucs" label="外祖父" label-width="80px" style="width: 100%;">
              <el-input maxlength="200" show-word-limit type="textarea" v-model="from.AnswerName13A_4"></el-input>
            </el-form-item>

            <el-form-item v-if="from.AnswerName13A == '0'" class="hiucs" label="外祖母" label-width="80px" style="width: 100%;">
              <el-input maxlength="200" show-word-limit type="textarea" v-model="from.AnswerName13A_6"></el-input>
            </el-form-item>

            <el-form-item v-if="from.AnswerName13A == '0'" class="hiucs" label="其他" label-width="80px" style="width: 100%;">
              <el-input maxlength="200" show-word-limit type="textarea" v-model="from.AnswerName13A_7"></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 18px; font-weight: 700;">状态评估</p>
              </div>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 14px;">危机评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" class="hiucs2" label-width="260px" label="自我伤害风险" prop="AnswerName4"
              style="width: 100%;">
              <el-radio-group v-model="from.AnswerName20" prop="name">
                <el-radio style="padding-top: 10px;" label="0">
                  0 无自我伤害风险(常规性的咨询)
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="1">
                  1 有风险但能自控(关注风险的咨询)
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="2">
                  2 有风险不能完全自控(制定安全计划、报告相关机构)
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="3">
                  3 高风险完全不能自控(紧急综合干预、报告相关机构)
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" class="hiucs2" label-width="260px" label="伤害他人风险"
              style="width: 100%;">
              <el-radio-group v-model="from.AnswerName29">
                <el-radio style="padding-top: 10px;" label="0">
                  0 无伤害他人风险(常规性的咨询)
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="1">
                  1 有风险但能自控(关注风险的咨询)
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="2">
                  2 有风险不能完全自控(制定安全计划、报告相关机构)
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="3">
                  3 高风险完全不能自控(紧急综合干预、报告相关机构)
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" class="hiucs2" label-width="260px" label="自我照料危机" prop="UserID"
              style="width: 100%;">

              <el-radio-group v-model="from.AnswerName37">
                <el-radio style="padding-top: 10px;" label="0">
                  0 无自我照料问题（正常咨询）
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="1">
                  1 自我照料略有不足（关注风险的咨询）
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="2">
                  2 自我照料受损明显（制定安全计划、报告相关机构)
                </el-radio>
                <br />
                <el-radio style="padding-top: 10px;" label="3">
                  3 自我照料能力丧失（紧急综合干预、报告相关机构)
                </el-radio>
              </el-radio-group>

            </el-form-item>




            

            <el-form-item label-width="40px" style="width: 100%; border: none !important;">
              <h2 style="font-size: 14px;">保护因素</h2>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──咨询/求助动机" prop="AnswerName5">
              <el-radio-group v-model="from.AnswerName21">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──家庭支持" prop="AnswerName6">
              <el-radio-group v-model="from.AnswerName22">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──社会支持" prop="AnswerName7">
              <el-radio-group v-model="from.AnswerName23">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──问题解决能力">
              <el-radio-group v-model="from.AnswerName24">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──活下去的希望" prop="AnswerName9">
              <el-radio-group v-model="from.AnswerName25">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──积极的宗教信仰" prop="AnswerName10">
              <el-radio-group v-model="from.AnswerName26">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>
            
            <el-form-item disabled="true" label-width="260px" label="保护因素评估──自知力" prop="AnswerName17">
              <el-radio-group v-model="from.AnswerName33">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──自制力" prop="AnswerName18">
              <el-radio-group v-model="from.AnswerName34">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="342px" label="保护因素评估──不想让有些/某个重要人物失望 " prop="AnswerName11"
              style="width: 100%;">
              <el-radio-group v-model="from.AnswerName27">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item class="svccsc" label="保护因素评估──其他相关因素" label-width="240px" style="width: 100%;">
              <el-input type="textarea" maxlength="400" show-word-limit v-model="from.AnswerName28"></el-input>
            </el-form-item>
<!-- 1111111111111 -->
            

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──咨询/求助动机" prop="AnswerName14">
              <el-radio-group v-model="from.AnswerName30">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item> -->

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──社会支持" prop="AnswerName15">
              <el-radio-group v-model="from.AnswerName31">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item> -->

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──问题解决能力" prop="AnswerName16">
              <el-radio-group v-model="from.AnswerName32">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item> -->

            

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──积极的宗教信仰" prop="AnswerName19">
              <el-radio-group v-model="from.AnswerName35">
                <el-radio label="0">强</el-radio>
                <el-radio label="1">弱</el-radio>
                <el-radio label="2">无</el-radio>
              </el-radio-group>
            </el-form-item> -->

            <!-- <el-form-item class="svcsscsc" label="保护因素评估──其他相关因素" label-width="260px" prop="AnswerName20"
              style="width: 100%;">
              <el-input type="textarea" maxlength="400" show-word-limit v-model="from.AnswerName36"></el-input>
            </el-form-item> -->

            <!-- <el-form-item label-width="40px" style="border: none !important;">
              <h2 style="font-size: 14px;">自我照料危机</h2>
            </el-form-item> -->

            

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-weight: 700;">一般精神状态评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="焦虑表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName38">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName38 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入焦虑表现与/或症状说明" show-word-limit type="textarea" v-model="from.AnswerName38Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="注意力缺陷/多动表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName39">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName39 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入注意力缺陷/多动表现与/或症状说明" show-word-limit type="textarea" v-model="from.AnswerName39Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="抑郁/低落心境表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName40">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName40 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入抑郁/低落心境表现与/或症状说明" show-word-limit type="textarea" v-model="from.AnswerName40Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="饮食不规律表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName41">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName41 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入饮食不规律表现与/或症状说明" show-word-limit type="textarea" v-model="from.AnswerName41Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="躁狂/轻度躁狂表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName42">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName42 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入躁狂/轻度躁狂表现与/或症状说明" show-word-limit type="textarea" v-model="from.AnswerName42Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="精神病性表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName43">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName43 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入精神病性表现与/或症状说明" show-word-limit type="textarea" v-model="from.AnswerName43Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="自伤倾向表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName44">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName44 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入症状说明" show-word-limit type="textarea" v-model="from.AnswerName44Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="睡眠问题表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName45">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName45 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入症状说明" show-word-limit type="textarea" v-model="from.AnswerName45Detail"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="物质滥用史表现与/或症状" prop="UserID">
              <el-radio-group v-model="from.AnswerName46">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否认</el-radio>
                <el-radio label="2">未确定</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item v-if="from.AnswerName46 == '0'" class="hiucs" label="说明" label-width="80px" style="width: 100%;">
              <el-input maxlength="100" placeholder="请输入症状说明" show-word-limit type="textarea" v-model="from.AnswerName46Detail"></el-input>
            </el-form-item>

            <el-form-item label="备注" class="hiucs" label-width="80px" style="width: 100%;">
              <el-input maxlength="400" show-word-limit type="textarea" v-model="from.AnswerName47"></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-weight: 700;">当前状况及社会功能评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="社会功能" prop="UserID">
              <el-radio-group v-model="from.AnswerName48">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="工作状况" prop="UserID">
              <el-radio-group v-model="from.AnswerName49">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="家庭支持" prop="UserID">
              <el-radio-group v-model="from.AnswerName50">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="社会支持" prop="UserID">
              <el-radio-group v-model="from.AnswerName51">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="其他" label-width="80px">
              <el-input class="qxs1" v-model="from.AnswerName52" maxlength="50"></el-input>
              <!-- <el-radio-group v-model="from.AnswerName52">
                <el-radio label="0">极好</el-radio>
                <el-radio label="1">好</el-radio>
                <el-radio label="2">不好</el-radio>
                <el-radio label="3">极差</el-radio>
              </el-radio-group> -->
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;font-weight: 700;">
                <p>来自咨询师的评估印象</p>
              </div>
            </el-form-item>

            <el-form-item label="来访者" label-width="80px" style="width: 100%;">
              <p>
                来访者:
                <span>{{ wonedata.UserName }}</span>
                因
                <el-input class="qxs1" v-model="from.AnswerName54" maxlength="100"></el-input>
                等原因，处于
                <el-input class="qxs1" v-model="from.AnswerName55" maxlength="100"></el-input>
                状态，存在
                <el-input class="qxs1" v-model="from.AnswerName56" maxlength="50"></el-input>
                的情况。
              </p>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;font-weight: 700;">
                <p>咨询记录</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="咨询主题" style="width: 100%;">
              <el-checkbox-group v-model="from.AnswerName61" :max="3" style="margin-left: 40px;">
                <el-checkbox v-for="item in uxskxns" :key="item.dicKey" :label="item.dicKey" name="type">{{ item.cDicValue }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="其他说明" label-width="100px">
              <el-input maxlength="100" class="qxs1" style="width: 400px;" v-model="from.AnswerName61A"></el-input>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;font-weight: 700;">
                <p>本次咨询目标与过程概要</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%;">
              <p style="margin-left: 20px;">
                针对来访者:
                <el-input class="qxs1" v-model="from.AnswerName62" maxlength="100"></el-input>
                的情况/困扰,经与来访者商讨确定本次咨询的目标为
                <el-input class="qxs1" v-model="from.AnswerName6" maxlength="100"></el-input>
              </p>
            </el-form-item>

            <el-form-item disabled="true" label-width="96px" label="采用方法" style="width: 100%;">
              <el-checkbox-group v-model="from.AnswerName64" :max="3" style="margin-left: 40px;">
                <!-- uxskxnscfde -->
                <el-checkbox v-for="item in uxskxnscfde" :key="item.dicKey" :label="item.dicKey" name="type">{{ item.cDicValue }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="其他说明" label-width="100px">
              <el-input maxlength="100" class="qxs1" style="width: 400px;" v-model="from.AnswerName64Detail"></el-input>
            </el-form-item>

            <el-form-item label="达成目标" label-width="100px">
              <el-input style="width: 400px;" class="qxs1" v-model="from.AnswerName65"></el-input>
            </el-form-item>

            <el-form-item disabled="true" label-width="154px" label="是否布置家庭作业">
              <el-radio-group v-model="from.AnswerName66">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 22px;">
                  改善状况
                  <span style="font-size: 16px; color: rgba(158, 158, 158, 1);">
                    本次咨询结束后，改善状态如何？
                  </span>
                </p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="情绪" prop="UserID">
              <el-radio-group v-model="from.AnswerName67">
                <el-radio label="0">明显改善</el-radio>
                <el-radio label="1">有所改善</el-radio>
                <el-radio label="2">轻微改善</el-radio>
                <el-radio label="3">无明显改善</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="认知" prop="UserID">
              <el-radio-group v-model="from.AnswerName68">
                <el-radio label="0">明显改善</el-radio>
                <el-radio label="1">有所改善</el-radio>
                <el-radio label="2">轻微改善</el-radio>
                <el-radio label="3">无明显改善</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="行为" prop="UserID">
              <el-radio-group v-model="from.AnswerName69">
                <el-radio label="0">明显改善</el-radio>
                <el-radio label="1">有所改善</el-radio>
                <el-radio label="2">轻微改善</el-radio>
                <el-radio label="3">无明显改善</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item class="bagtit" style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 22px;">咨询过程记录</p>
              </div>
            </el-form-item>

            <el-form-item label-width="124px" class="bvds" style="margin-left: 20px;">
              <el-input maxlength="1000" show-word-limit type="textarea" v-model="from.AnswerName70">
              </el-input>
            </el-form-item>

          </el-form>

        </div>
      </div>

      <div style="text-align: center;">
        <el-button type="warning" @click="WPPdialogClose">关闭</el-button>
        <el-button type="success" :loading="loadingpd" @click="dialogV">保存</el-button>
        <el-button type="primary" @click="Temporary_storage()">暂存</el-button>
      </div>
      
      <!-- <div style="text-align: center;">
        <el-button type="warning" @click="WPPdialogClose">关闭</el-button>
        <el-button type="success" :loading="loadingpd" @click="dialogV">保存</el-button>
      </div> -->
      
    </el-dialog>
    <el-dialog :visible.sync="WPPdialogVisible2" width="80%" :before-close="handleClose">
      <div class="filein">
        <div class="filein-top">
          <p class="filein-top-p1">
            <span>
              {{ wonedata.UserName }}(<span>来访者</span>)
              <i>{{ wonedata.Status }}</i>
            </span>
          </p>
          <el-form style="margin:0 20px">
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">咨询方式：{{ wonedata.ConsultType }}</el-col>
                <el-col :span="6">咨询地点：{{ wonedata.Address}}</el-col>
                <el-col :span="6">联系方式：{{ wonedata.Phone}}</el-col>
                <el-col :span="6">预约时间：{{ wonedata.AppointmentTime}}</el-col>
              </el-row>
            </el-form-item>
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">婚姻状态：{{wonedata.MarriageState == 0?'未婚':'已婚'}}</el-col>
                <el-col :span="6">性别：{{ wonedata.Sex }}</el-col>
                <el-col :span="6">年龄：{{ wonedata.Age }}</el-col>
                <el-col :span="6">咨询时间：{{ wonedata.ConsultTime}}</el-col>
              </el-row>
            </el-form-item>
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">剩余次数：{{wonedata.Balance}}</el-col>
                <el-col :span="6">所属院系所：{{wonedata.DeptName}}</el-col>
                <el-col :span="6">目前年级：{{wonedata.EntryDate}}</el-col>
              </el-row>
            </el-form-item>
          </el-form>
         <el-button @click="wexport">导出报告</el-button>
        </div>
        <div class="filein-button">
          <h2>个人情况</h2>
          <h3>知情同意</h3>
          <el-form :inline="true" :model="from" ref="from" label-width="100px" class="demo-ruleForm">
            <el-form-item disabled="true" label-width="276px" label="保密原则告知和解释（书面和口头）" prop="AnswerName1">
              <span style="margin-left:20px">{{ wonedata2.AnswerName1 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="234px" label="知情同意讨论（书面和口头）" prop="AnswerName2">
              <span style="margin-left:20px">{{ wonedata2.AnswerName2 }}</span>
            </el-form-item>

            <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName3 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>来访者问题主诉</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%;">
              <p style="margin-left: 20px;"> {{ wonedata2.QuestionName4 }}<span>{{ wonedata2.AnswerName4 }}</span>来寻求咨询帮助
                <!-- ，希望咨询师就<span>{{ wonedata2.AnswerName5 }}</span>的情况提供帮助。 -->
              </p>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>
                  相关健康史
                  <span>（重大疾病史）</span>
                </p>
              </div>
            </el-form-item>

            <el-form-item label-width="120px" style="margin-left: 20px;">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName7 }}
              </span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>个人成长史</p>
              </div>
            </el-form-item>

            <el-form-item label-width="40px" style="width: 100%; border: none !important;">
              <h2 style="font-size: 14px;">创伤史</h2>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="重大丧失" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName8 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName8 == '是'" disabled="true" label-width="120px" label="重大丧失说明" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName8Detail }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="暴力侵害" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName9 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName9 == '是'" disabled="true" label-width="120px" label="暴力侵害说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName9Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="性侵害" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName10 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName10 == '是'" disabled="true" label-width="120px" label="性侵害说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName10Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="被忽视" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName11 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName11 == '是'" disabled="true" label-width="120px" label="被忽视说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName11Detail }}
              </span>
            </el-form-item>

            <!-- <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName12 }}</span>
            </el-form-item> -->
            <br/>
            <!-- <el-form-item label-width="40px" style="width: 100%; border: none !important;">
              <h2 style="font-size: 14px;">家族史11111</h2>
            </el-form-item> -->

            <el-form-item disabled="true" label-width="120px" label="家族史" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="父亲" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_1}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="母亲" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_2}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="祖父" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_3 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="外祖父" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_4}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="祖母" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_5}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="外祖母" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_6 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="其他" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_7 }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="精神病史" prop="UserID" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName13 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13 == '是'" disabled="true" label-width="120px" label="精神病史说明" prop="UserID">
                <span style="margin-left:20px">
                  {{ wonedata2.AnswerName13Detail }}
                </span>
              </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="自杀自伤" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName14 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName14 == '是'" disabled="true" label-width="120px" label="自杀自伤说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName14Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="130px" label="暴力攻击倾向" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName16 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName16 == '是'" disabled="true" label-width="150px" label="暴力攻击倾向说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName16Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="酒精滥用" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName17 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName17 == '是'" disabled="true" label-width="120px" label="酒精滥用说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName17Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="物质滥用" prop="UserID" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName18 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName18 == '是'" disabled="true" label-width="120px" label="物质滥用说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName18Detail }}
              </span>
            </el-form-item>

            <!-- <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName19 }}
              </span>
            </el-form-item> -->

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 18px; font-weight: 700;">状态评估</p>
              </div>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 14px;">危机评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="自我伤害风险" prop="AnswerName4"
              style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName20 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="伤害他人危机"
              style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName29 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="146px" label="自我照料危机" prop="UserID" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName37 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 14px;">保护因素</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──咨询/求助动机" prop="AnswerName5">
              <span style="margin-left:20px">{{ wonedata2.AnswerName21 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──家庭支持" prop="AnswerName6">
              <span style="margin-left:20px">{{ wonedata2.AnswerName22 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──社会支持" prop="AnswerName7">
              <span style="margin-left:20px">{{ wonedata2.AnswerName23 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──问题解决能力">
              <span style="margin-left:20px">{{ wonedata2.AnswerName24 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──活下去的希望" prop="AnswerName9">
              <span style="margin-left:20px">{{ wonedata2.AnswerName25 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──积极的宗教信仰" prop="AnswerName10">
              <span style="margin-left:20px">{{ wonedata2.AnswerName26 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="342px" label="保护因素评估──不想让有些/某个重要人物失望 " prop="AnswerName11"
              style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName27 }}</span>
            </el-form-item>

            <el-form-item class="hiucs" label="保护因素评估──其他相关因素" label-width="240px" style="width: 100%;">
              <span >{{ wonedata2.AnswerName28 }}</span>
            </el-form-item>

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──咨询/求助动机" prop="AnswerName14">
              <span style="margin-left:20px">{{ wonedata2.AnswerName30 }}</span>
            </el-form-item> -->

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──社会支持" prop="AnswerName15">
              <span style="margin-left:20px">{{ wonedata2.AnswerName31 }}</span>
            </el-form-item> -->

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──问题解决能力" prop="AnswerName16">
              <span style="margin-left:20px">{{ wonedata2.AnswerName32 }}</span>
            </el-form-item> -->

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──自知力" prop="AnswerName17">
              <span style="margin-left:20px">{{ wonedata2.AnswerName33 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──自制力" prop="AnswerName18">
              <span style="margin-left:20px">{{ wonedata2.AnswerName34 }}</span>
            </el-form-item>

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──积极的宗教信仰" prop="AnswerName19">
              <span style="margin-left:20px">{{ wonedata2.AnswerName35 }}</span>
            </el-form-item> -->

            <!-- <el-form-item label="保护因素评估──其他相关因素" label-width="260px" prop="AnswerName20" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName36 }}</span>
            </el-form-item> -->


            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>一般精神状态评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="174px" label="焦虑表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName38 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName38 == '是'" disabled="true" label-width="190px" label="焦虑表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName38Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="250px" label="注意力缺陷/多动表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName39 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName39 == '是'" disabled="true" label-width="260px" label="注意力缺陷/多动表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName39Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="234px" label="抑郁/低落心境表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName40 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName40 == '是'" disabled="true" label-width="250px" label="抑郁/低落心境表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName40Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="212px" label="饮食不规律表现与/或症状" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName41 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName41 == '是'" disabled="true" label-width="240px" label="饮食不规律表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName41Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="232px" label="躁狂/轻度躁狂表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName42 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName42 == '是'" disabled="true" label-width="250px" label="躁狂/轻度躁狂表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName42Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="198px" label="精神病性表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName43 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName43 == '是'" disabled="true" label-width="220px" label="精神病性表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName43Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="198px" label="自伤倾向表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName44 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName44 == '是'" disabled="true" label-width="220px" label="自伤倾向表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName44Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="198px" label="睡眠问题表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName45 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName45 == '是'" disabled="true" label-width="220px" label="睡眠问题表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName45Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="212px" label="物质滥用史表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName46 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName46 == '是'" disabled="true" label-width="230px" label="物质滥用史表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName46Detail }}
              </span>
            </el-form-item>

            <el-form-item label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName47 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>当前状况及社会功能评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="社会功能" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName48 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="工作状况" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName49 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="家庭支持" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName50 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="社会支持" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName51 }}</span>
            </el-form-item>

            <el-form-item label="其他" label-width="80px">
              <span style="margin-left:20px">{{ wonedata2.AnswerName52 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>来自咨询师的评估印象</p>
              </div>
            </el-form-item>

            <el-form-item label="来访者" label-width="80px" style="width: 100%;">
              <p>
                来访者:
                <span>{{ wonedata.UserName }}</span>
                因
                <span>{{ wonedata2.AnswerName54 }}</span>
                等原因，处于
                <span>{{ wonedata2.AnswerName55 }}</span>
                状态，存在
                <span>{{ wonedata2.AnswerName56 }}</span>
                的情况。
              </p>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>咨询记录</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="96px" label="咨询主题" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.An61_1Two }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="96px" label="其他说明" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName61A }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>本次咨询目标与过程概要</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%;">
              <p style="margin-left: 20px;">
                针对来访者:
                <span style="margin-left:20px;margin-left:20px">{{ wonedata2.AnswerName62 }}</span>
                的情况/困扰,经与来访者商讨确定本次咨询的目标为
                <span style="margin-left:20px;margin-left:20px">{{ wonedata2.AnswerName6 }}</span>
              </p>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="采用方法" >
              <span style="margin-left:20px">{{ wonedata2.An64_1Two }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName64Detail" disabled="true" label-width="140px" label="采用方法说明">
              <span style="margin-left:20px">{{ wonedata2.AnswerName64Detail }}</span>
            </el-form-item>

            <el-form-item label="达成目标" label-width="98px">
              <span style="margin-left:20px">{{ wonedata2.AnswerName65 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="154px" label="是否布置家庭作业">
              <span style="margin-left:20px">{{ wonedata2.AnswerName66 == 1? '否':'是' }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 22px;">
                  改善状况
                  <span style="font-size: 16px; color: rgba(158, 158, 158, 1);">
                    本次咨询结束后，改善状态如何？
                  </span>
                </p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="74px" label="情绪" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName67 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="74px" label="认知" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName68 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="74px" label="行为" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName69 }}</span>
            </el-form-item>

            <el-form-item style="width: 98%;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 22px;">咨询过程记录</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 98%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName70 }}</span>
            </el-form-item>

            <el-form-item label="咨询主管点评" label-width="120px" style="width: 98%;">
              <span style="margin-left:20px">{{ wonedata2.Evaluation }}</span>
            </el-form-item>

            <el-form-item v-if="this.Global.pdroleid(1066)" label="咨询主管点评" label-width="120px" style="width: 98%;">
              <el-input maxlength="30"
  show-word-limit style="margin-left:20px" type="textarea" :rows="2" placeholder="请输入点评内容" v-model="glypj"></el-input>
            </el-form-item>

            <el-button v-if="this.Global.pdroleid(1066)" type="primary" style="margin-left:48%" @click="giypj()">评价</el-button>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="WPPdialogVisible3" width="80%" :before-close="handleClose">
      <div>
        <span>咨询师搜索：</span>
        <el-select v-model="wppvalue2" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod2" :loading="wpploading2">
          <el-option v-for="item in wppoptions2" :key="item.UserID" :label="item.RealName" :value="item.UserID">
          </el-option>
        </el-select>
        <span style="margin-left: 20px;">学生搜索：</span>
        <el-select v-model="wppvalue" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="wpploading">
          <el-option v-for="item in wppoptions" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
        </el-select>
        <el-button type="primary" style="margin-left: 20px;" @click="bgcs">
          搜索
        </el-button>
      </div>
      <div class="paiban">
        <ul class="ClientConsulting_right_top">
          <li v-for="item in paiban" :key="item.index">
            <p>{{ item.DateS }}</p>
            <p>{{ item.Days }}</p>
          </li>
        </ul>
        <ul class="ClientConsulting_right_ul">
          <li>
            <ul v-if="paiban[0]">
              <li v-for="items in paiban[0].ZhanTimes" :key="items.index">
                {{ items.StartTime }}-{{ items.FinishTime }}

                <p v-if="items.States == 4" @click="(items)">
                  点击预约
                </p>
                <p v-else-if="items.States == 1" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  没排班
                </p>
                <p v-else-if="items.States == -1" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  咨询师拒绝
                </p>
                <p v-else-if="items.States == 2" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  他人已预约
                </p>
                <p v-else-if="items.States == 3">已预约</p>
                <p v-else-if="items.States == 5" style="background-color: rgba(5, 34, 50, 1); color: rgba(35, 75, 83, 1);">
                  心理中心取消
                </p>
                <i v-if="items.States == 3">
                  已预约
                  <span @click="wcancel(items.ConsultSchID, items.AppointmentID)">
                    取消预约
                  </span>
                </i>
              </li>
            </ul>
          </li>
          <li>
            <ul v-if="paiban[1]">
              <li v-for="items1 in paiban[1].ZhanTimes" :key="items1.index">
                {{ items1.StartTime }}-{{ items1.FinishTime }}
                <p v-if="items1.States == 4" @click="dialogVisibles(items1)">
                  点击预约
                </p>
                <p v-else-if="items1.States == 1"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                <p v-else-if="items1.States == -1" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                <p v-else-if="items1.States == 2"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                <p v-else-if="items1.States == 3">已预约</p>
                <p v-else-if="items1.States == 5"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  心理中心取消
                </p>
                <i v-if="items1.States == 3">
                  已预约
                  <span @click="wcancel()">取消预约</span>
                </i>
              </li>
            </ul>
          </li>
          <li>
            <ul v-if="paiban[2]">
              <li v-for="items2 in paiban[2].ZhanTimes" :key="items2.index">
                {{ items2.StartTime }}-{{ items2.FinishTime }}
                <p v-if="items2.States == 4" @click="dialogVisibles(items2)">
                  点击预约
                </p>
                <p v-else-if="items2.States == 1" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  没排班
                </p>
                <p v-else-if="items2.States == -1" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  咨询师拒绝
                </p>
                <p v-else-if="items2.States == 2" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  他人已预约
                </p>
                <p v-else-if="items2.States == 3">已预约</p>
                <p v-else-if="items2.States == 5" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  心理中心取消
                </p>
                <i v-if="items2.States == 3">
                  已预约
                  <span>取消预约</span>
                </i>
              </li>
            </ul>
          </li>
          <li>
            <ul v-if="paiban[3]">
              <li v-for="items3 in paiban[3].ZhanTimes" :key="items3.index">
                {{ items3.StartTime }}-{{ items3.FinishTime }}
                <p v-if="items3.States == 4" @click="dialogVisibles(items3)">
                  点击预约
                </p>
                <p v-else-if="items3.States == 1" style="background-color: rgba(5, 34, 50, 1);color:rgba(35, 75, 83, 1);">
                  没排班
                </p>
                <p v-else-if="items3.States == -1" style="background-color: rgba(5, 34, 50, 1);color:rgba(35, 75, 83, 1);">
                  咨询师拒绝
                </p>
                <p v-else-if="items3.States == 2" style="background-color: rgba(5, 34, 50, 1);color:rgba(35, 75, 83, 1);">
                  他人已预约
                </p>
                <p v-else-if="items3.States == 3">已预约</p>
                <p v-else-if="items3.States == 5" style="background-color: rgba(5, 34, 50, 1);color:rgba(35, 75, 83, 1);">
                  心理中心取消
                </p>
                <i v-if="items3.States == 3">
                  已预约
                  <span>取消预约</span>
                </i>
              </li>
            </ul>
          </li>

          <li>
            <ul v-if="paiban[4]">
              <li v-for="items4 in paiban[4].ZhanTimes" :key="items4.index">
                {{ items4.StartTime }}-{{ items4.FinishTime }}
                <p v-if="items4.States == 4" @click="dialogVisibles(items4)">点击预约</p>
                <p v-else-if="items4.States == 1"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                <p v-else-if="items4.States == -1" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                <p v-else-if="items4.States == 2"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                <p v-else-if="items4.States == 3">已预约</p>
                <p v-else-if="items4.States == 5"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">心理中心取消</p>
                <i v-if="items4.States == 3">已预约<span>取消预约</span></i>
              </li>
            </ul>
          </li>

          <li>
            <ul v-if="paiban[5]">
              <li v-for="items5 in paiban[5].ZhanTimes" :key="items5.index">
                {{ items5.StartTime }}-{{ items5.FinishTime }}
                <p v-if="items5.States == 4" @click="dialogVisibles(items5)">点击预约</p>
                <p v-else-if="items5.States == 1"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">没排班</p>
                <p v-else-if="items5.States == -1" style="background-color:rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">咨询师拒绝</p>
                <p v-else-if="items5.States == 2"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">他人已预约</p>
                <p v-else-if="items5.States == 3">已预约</p>
                <p v-else-if="items5.States == 5"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">心理中心取消</p>
                <i v-if="items5.States == 3">
                  已预约
                  <span>取消预约</span>
                </i>
              </li>
            </ul>
          </li>

          <li>
            <ul v-if="paiban[6]">
              <li v-for="items6 in paiban[6].ZhanTimes" :key="items6.index">
                {{ items6.StartTime }}-{{ items6.FinishTime }}
                <p v-if="items6.States == 4" @click="dialogVisibles(items6)">
                  点击预约
                </p>
                <p v-else-if="items6.States == 1"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  没排班
                </p>
                <p v-else-if="items6.States == -1" style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  咨询师拒绝
                </p>
                <p v-else-if="items6.States == 2"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  他人已预约
                </p>
                <p v-else-if="items6.States == 3">已预约</p>
                <p v-else-if="items6.States == 5"  style="background-color: rgba(5, 34, 50, 1);color: rgba(35, 75, 83, 1);">
                  心理中心取消
                </p>
                <i v-if="items6.States == 3">
                  已预约
                  <span>取消预约</span>
                </i>
              </li>
            </ul>
          </li>
        </ul>

      </div>
    </el-dialog>

    <el-dialog  class="xaxoaixh" :visible.sync="pddialogVisible" width="800px" :before-close="handleClose">

      <h2 style="font-size: 18px;">请对心理咨询师打分</h2>

      <div style="height: 40px;margin-top: 20px;position: relative;">
        <span class="demonstration">专业能力</span>
          <el-rate v-model="FiveStar1" :colors="colors">
        </el-rate>
      </div>

      <div style="height:40px;margin-top:1px;position:relative;">
        <span class="demonstration">专业态度</span>
          <el-rate v-model="FiveStar2" :colors="colors">
        </el-rate>
      </div>

      <div style="height:40px;margin-top:1px;position:relative;">
        <span class="demonstration">专业素养</span>
          <el-rate v-model="FiveStar3" :colors="colors">
        </el-rate>
      </div>

      <div style="height:40px;margin-top:1px;position:relative;">
        <span class="demonstration">请选择对咨询师服务印象</span>
        <el-checkbox-group v-model="ServiceImpress" style="position: absolute;top: 4px;left: 190px;">
          <el-checkbox v-for="item in GetDictionaryListdata" :key="item.dicKey" style="padding-top: 8px;" :label="item.dicKey" name="type">{{ item.cDicValue}}</el-checkbox>
        </el-checkbox-group>
      </div>

      <div style="height:80px;margin-top:50px;position:relative;">
        <span class="demonstration">建议</span>
        <el-input style="position: absolute;top: 0px;left: 50px;height: 50px;" type="textarea" :rows="2" placeholder="请输入内容"  v-model="Suggestion">
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-if="pdroleid(1058)" type="primary" @click="pdclis()">提交</el-button>
      </span>

  </el-dialog>

    <el-dialog :visible.sync="WPPdble" width="800px" :before-close="handleClose">
      <div v-html="ConsultRecord"></div>
    </el-dialog>
  </div>
  <Crisiscases ref="childdetail"></Crisiscases>
  </div>
</template>

<script>
import moment from 'moment';
import Crisiscases from './Crisiscases.vue';
export default {
  data() {
    return {
      consultanswerkey:'',
      glypj:'',
      ConsultRecord:'',
      WPPdble:false,
      uxskxnscfde: [],
      uxskxns: [],
      uxskxnsww: [],
      campus_list:[],
      FiveStar1:0,
      FiveStar2:0,
      FiveStar3:0,
      FiveStar4:0,
      FiveStar5: 0,
      ServiceImpress: [],
      Suggestion: '',
      resdata:'',
      RoleID: '',
      Campus: [],
      GetDictionaryListdata:[],
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      pddialogVisible:false,
      cscscscscgvd: '黄金糕',
      ConsultPaperTime: '',
      paiban: [],
      wppoptions: [],
      wppoptions2: [],
      wpploading: false,
      wpploading2: false,
      wppvalue: '',
      wppvalue2: '',
      entity: sessionStorage.getItem('entity'),
      filterObj: [],
      wonedata: '',
      wonedata2: '',
      WPPdialogVisible: false,
      WPPdialogVisible2: false,
      WPPdialogVisible3: false,
      showViewDetails: false,
      currentPage1: 1,
      Counts: 1,
      pageSize: 10,
      pageIndex: 0,
      DetailsInfo: {
        UserName: '', //来访者
        ConsultTime: '', // 咨询时间
        ConAddressName: '', // 咨询地点
        ConsultType: '', // 咨询方式
        Status: '', // 咨询状态
        ResidueCount: '', // 剩余次数
        SchedulDate: '', // 预约时间
      },
      detailsdata: '',
      from: {
        AnswerName1: '',
        AnswerName2: '',
        AnswerName3: '',
        AnswerName4: '',
        AnswerName5: '',
        AnswerName6: '',
        AnswerName7: '',
        AnswerName8: '',
        AnswerName8Detail: '',
        AnswerName9: '',
        AnswerName9Detail: '',
        AnswerName10: '',
        AnswerName10Detail: '',
        AnswerName11: '',
        AnswerName11Detail: '',
        AnswerName12: '',
        AnswerName13: '',
        AnswerName13A: '',
        AnswerName13A_1: '',
        AnswerName13A_2: '',
        AnswerName13A_3: '',
        AnswerName13A_4: '',
        AnswerName13A_5: '',
        AnswerName13A_6: '',
        AnswerName13A_7: '',
        AnswerName13Detail: '',
        AnswerName13_1: [],
        AnswerName14Detail: '',
        AnswerName14: '',
        AnswerName15: '',
        AnswerName15Detail: '',
        AnswerName16: '',
        AnswerName16Detail: '',
        AnswerName17: '',
        AnswerName17Detail: '',
        AnswerName18: '',
        AnswerName18Detail: '',
        AnswerName19: '',
        AnswerName20: '',
        AnswerName21: '',
        AnswerName22: '',
        AnswerName23: '',
        AnswerName24: '',
        AnswerName25: '',
        AnswerName26: '',
        AnswerName27: '',
        AnswerName28: '',
        AnswerName29: '',
        // AnswerName30: '',
        // AnswerName31: '',
        // AnswerName32: '',
        AnswerName33: '',
        AnswerName34: '',
        // AnswerName35: '',
        // AnswerName36: '',
        AnswerName37: '',
        AnswerName38: '',
        AnswerName38Detail: '',
        AnswerName39: '',
        AnswerName39Detail: '',
        AnswerName40: '',
        AnswerName40Detail: '',
        AnswerName41: '',
        AnswerName41Detail: '',
        AnswerName42: '',
        AnswerName42Detail: '',
        AnswerName43: '',
        AnswerName43Detail: '',
        AnswerName44: '',
        AnswerName44Detail: '',
        AnswerName45: '',
        AnswerName45Detail: '',
        AnswerName46: '',
        AnswerName46Detail: '',
        AnswerName47: '',
        AnswerName48: '',
        AnswerName49: '',
        AnswerName50: '',
        AnswerName51: '',
        AnswerName52: '',
        AnswerName53: '',
        AnswerName54: '',
        AnswerName55: '',
        AnswerName56: '',
        AnswerName57: '',
        AnswerName58: '',
        AnswerName59: '',
        AnswerName60: '',
        AnswerName61: [],
        AnswerName61A: '',
        AnswerName62: '',
        AnswerName63: '',
        AnswerName64: [],
        AnswerName64Detail: '',
        AnswerName65: '',
        AnswerName66: '',
        AnswerName67: '',
        AnswerName68: '',
        AnswerName69: '',
        AnswerName70: '',//家族史
        AnswerName71: '',//
        AnswerName72: '',//
        AnswerName73: '',//
        AnswerName74: '',//
        AnswerName75: '',//
        AnswerName76: '',//
        AnswerName77: '',//
        AnswerName78: '',//
        AnswerName79: '',//
        AnswerName80: '',//
        AppointmentID: '',
        AppointmentKey: '',
        UserID: '',
        Counselor: '',
        Riqi: '',
        Status: '5',
      },
      tAnswerKey:'',
      loadingpd:false,
      pdtj:1,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      ruleForm: {
        CounselorInfo: '',
        UserInfo: '',
        ConsultType: '',
        Campus: '',
        UserTime: null,
        AppointmentTime: null,
        
      },
      dialogVisible: false,
      IsLoading: true,
      IsDialogLoading: false,
      AppointList: [
        {
          AppointmentID: 'app01',
          SchedulID: 'Sch001',
          UserID: '01',
          UserName: '张三',
          Status: '已预约',
          DeptName: '经济管理学院',
          ConsultTime: '2022-02-15 08:00:00-09:00:00',
          AppointmentTime: '2022-02-14 08:25:36',
          ConsultType: '线下咨询',
        },
      ],
      CurrentItem: {
        Basic: {
          姓名: '张三',
          学号: '01',
          性别: '男',
          婚姻状态: '已婚',
          年龄: 30,
          身份证号: '360430189565421563',
          现居住地址: '上海市浦东新区',
          联系电话: '13526545869',
          邮箱: '543166216@126.com',
          汉族: '汉族',
          国家地区: '中国上海',
          宗教信仰: '佛教',
          所在单位: '经济管理学院',
          紧急联系人: '张四',
          联系方式: '13652658965',
          关系: '父亲',
        },
        Family: {
          是否独生子女: '是（自己在家里排行第一）',
          家庭所在地类型: '城市',
          是否享受我校贫困生相关政策及补助: '否',
          父亲文化程度: '初中',
          母亲文化程度: '小学',
          目前家庭情况: '原生家庭',
          你如何评价自己家庭的经济状况: '1分',
          对家庭的喜欢程度: '2分',
          家庭成员: '5分',
        },
        Questionnaire: {
          咨询方式: '视频咨询',
          咨询主题: '恋爱问题',
          问题描述: '送到了飞机拉三等奖来访按时交党费',
          你是否有过自杀及伤害他人的想法或经历: '是',
          你是否有攻击他人的行为: '否',
          你是否曾经在精神科就医: '是',
        },
        PaperTestResult: {
          SASScore: 78,
          SASResultID: '1e611012-178f-420a-8469-d0c2b785330e',
          SDSScore: 65,
          SDSResultID: '1639b50c-b7b5-40e8-a2ea-a2f46c11a1f9',
        },
      },
      padhnk:'',
    };
  },
  created() {
    this.consulting('123', '');
  },
  mounted() {

    this.$Http_Post('ConsultSubscribe/GetCurrentTerm').then((res) => {
      if (res.Code == 200 || res.Code == 0) {

        if(res.Data){
          this.padhnk = res.Data
          this.ruleForm.UserTime = res.Data.split(',')
          this.Init();
        }else{
          this.ruleForm.UserTime = this.Global.querycensus(6)
          this.Init();
        }

      }
    })

    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 25 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.uxskxns  = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 20 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.uxskxnscfde = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 19 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.uxskxnsww = res.Data;
      }
    })

    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 16 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.campus_list = res.Data;
        this.Campus = res.Data[0].dicKey;
      }
    })
    this.RoleID = sessionStorage.getItem('RoleID');
    this.$Http_Post('User/GetDictionaryList', {
      DicTypCode: 30,
    }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetDictionaryListdata = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    });
  },
  methods: {
    Query_record(){
      this.pdtj = 2;
      this.$Http_Post('ConsultSubscribe/CopyConsultAnswer', {AppointmentKey:this.from.AppointmentID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
            this.tAnswerKey= res.Data.consultanswerkey
            this.from.AnswerName1= res.Data.AnswerName1
            this.from.AnswerName2= res.Data.AnswerName2
            this.from.AnswerName3= res.Data.AnswerName3
            this.from.AnswerName4= res.Data.AnswerName4
            this.from.AnswerName5= res.Data.AnswerName5
            this.from.AnswerName6= res.Data.AnswerName6
            this.from.AnswerName7= res.Data.AnswerName7
            this.from.AnswerName8= res.Data.AnswerName8
            this.from.AnswerName8Detail= res.Data.AnswerName8Detail
            this.from.AnswerName9= res.Data.AnswerName9
            this.from.AnswerName9Detail= res.Data.AnswerName9Detail
            this.from.AnswerName10= res.Data.AnswerName10
            this.from.AnswerName10Detail= res.Data.AnswerName10Detail
            this.from.AnswerName11= res.Data.AnswerName11
            this.from.AnswerName11Detail= res.Data.AnswerName11Detail
            this.from.AnswerName12= res.Data.AnswerName12
            this.from.AnswerName13= res.Data.AnswerName13
            this.from.AnswerName13A= res.Data.AnswerName13A
            this.from.AnswerName13A_1= res.Data.AnswerName13A_1
            this.from.AnswerName13A_2= res.Data.AnswerName13A_2
            this.from.AnswerName13A_3= res.Data.AnswerName13A_3
            this.from.AnswerName13A_4= res.Data.AnswerName13A_4
            this.from.AnswerName13A_5= res.Data.AnswerName13A_5
            this.from.AnswerName13A_6= res.Data.AnswerName13A_6
            this.from.AnswerName13A_7= res.Data.AnswerName13A_7
            this.from.AnswerName13Detail= res.Data.AnswerName13Detail
            this.from.AnswerName13_1=  res.Data.AnswerName13_1
            this.from.AnswerName14Detail= res.Data.AnswerName14Detail
            this.from.AnswerName14= res.Data.AnswerName14
            this.from.AnswerName15= res.Data.AnswerName15
            this.from.AnswerName15Detail= res.Data.AnswerName15Detail
            this.from.AnswerName16= res.Data.AnswerName16
            this.from.AnswerName16Detail= res.Data.AnswerName16Detail
            this.from.AnswerName17= res.Data.AnswerName17
            this.from.AnswerName17Detail= res.Data.AnswerName17Detail
            this.from.AnswerName18= res.Data.AnswerName18
            this.from.AnswerName18Detail= res.Data.AnswerName18Detail
            this.from.AnswerName19= res.Data.AnswerName19
            this.from.AnswerName20= res.Data.AnswerName20
            this.from.AnswerName21= res.Data.AnswerName21
            this.from.AnswerName22= res.Data.AnswerName22
            this.from.AnswerName23= res.Data.AnswerName23
            this.from.AnswerName24= res.Data.AnswerName24
            this.from.AnswerName25= res.Data.AnswerName25
            this.from.AnswerName26= res.Data.AnswerName26
            this.from.AnswerName27= res.Data.AnswerName27
            this.from.AnswerName28= res.Data.AnswerName28
            this.from.AnswerName29= res.Data.AnswerName29
            // this.from.AnswerName30= res.Data.AnswerName30
            // this.from.AnswerName31= res.Data.AnswerName31
            // this.from.AnswerName32= res.Data.AnswerName32
            this.from.AnswerName33= res.Data.AnswerName33
            this.from.AnswerName34= res.Data.AnswerName34
            // this.from.AnswerName35= res.Data.AnswerName35
            // this.from.AnswerName36= res.Data.AnswerName36
            this.from.AnswerName37= res.Data.AnswerName37
            this.from.AnswerName38= res.Data.AnswerName38
            this.from.AnswerName38Detail= res.Data.AnswerName38Detail
            this.from.AnswerName39= res.Data.AnswerName39
            this.from.AnswerName39Detail= res.Data.AnswerName39Detail
            this.from.AnswerName40= res.Data.AnswerName40
            this.from.AnswerName40Detail= res.Data.AnswerName40Detail
            this.from.AnswerName41= res.Data.AnswerName41
            this.from.AnswerName41Detail= res.Data.AnswerName41Detail
            this.from.AnswerName42= res.Data.AnswerName42
            this.from.AnswerName42Detail= res.Data.AnswerName42Detail
            this.from.AnswerName43= res.Data.AnswerName43
            this.from.AnswerName43Detail= res.Data.AnswerName43Detail
            this.from.AnswerName44= res.Data.AnswerName44
            this.from.AnswerName44Detail= res.Data.AnswerName44Detail
            this.from.AnswerName45= res.Data.AnswerName45
            this.from.AnswerName45Detail= res.Data.AnswerName45Detail
            this.from.AnswerName46= res.Data.AnswerName46
            this.from.AnswerName46Detail= res.Data.AnswerName46Detail
            this.from.AnswerName47= res.Date.AnswerName47
            this.from.AnswerName48= res.Data.AnswerName48
            this.from.AnswerName49= res.Data.AnswerName49
            this.from.AnswerName50= res.Data.AnswerName50
            this.from.AnswerName51= res.Data.AnswerName51
            this.from.AnswerName52= res.Data.AnswerName52
            this.from.AnswerName53= res.Data.AnswerName53
            this.from.AnswerName54= res.Data.AnswerName54
            this.from.AnswerName55= res.Data.AnswerName55
            this.from.AnswerName56= res.Data.AnswerName56
            this.from.AnswerName57= res.Data.AnswerName57
            this.from.AnswerName58= res.Data.AnswerName58
            this.from.AnswerName59= res.Data.AnswerName59
            this.from.AnswerName60= res.Data.AnswerName60
            this.from.AnswerName61= res.Data.AnswerName61
            this.from.AnswerName61A= res.Data.AnswerName61A
            this.from.AnswerName62= res.Data.AnswerName62
            this.from.AnswerName63= res.Data.AnswerName63
            this.from.AnswerName64= res.Data.AnswerName64
            this.from.AnswerName64Detail= res.Data.AnswerName64Detail,
            this.from.AnswerName65= res.Date.AnswerName65
            this.from.AnswerName66= res.Data.AnswerName66
            this.from.AnswerName67= res.Data.AnswerName6
            this.from.AnswerName68= res.Data.AnswerName68
            this.from.AnswerName69= res.Data.AnswerName69
            this.from.AnswerName70= res.Data.AnswerName70//家族史
            this.from.AnswerName71= res.Data.AnswerName71//
            this.from.AnswerName72= res.Data.AnswerName72//
            this.from.AnswerName73= res.Data.AnswerName73//
            this.from.AnswerName74= res.Data.AnswerName74//
            this.from.AnswerName75= res.Data.AnswerName75//
            this.from.AnswerName76= res.Data.AnswerName76//
            this.from.AnswerName77= res.Data.AnswerName77//
            this.from.AnswerName78= res.Data.AnswerName78//
            this.from.AnswerName79= res.Data.AnswerName79//
            this.from.AnswerName80= res.Data.AnswerName80//
        
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row)
      if (row.Crisis == 1) {
        return 'warning-row';
      } else if(row.Status =='心理中心取消' || row.Status =='自主取消'){
        return 'warning-row111';
      }
    },
    pdroleid(id) {
      var RoleID = sessionStorage.getItem('RoleID')
      if (RoleID.indexOf(id) !== -1) {
        return true
      } else {
        return false
      }
    },
    pdclis(val) {
      this.$Http_Post('ConsultAppoint/SubmitComment', {FiveStar1: this.FiveStar1, FiveStar2: this.FiveStar2, FiveStar3: this.FiveStar3, FiveStar4: this.FiveStar4, FiveStar5: this.FiveStar5,
        Suggestion: this.Suggestion, ServiceImpress: this.ServiceImpress.toString(), ConsultAnswerKey: this.resdata.AppointmentID, Counselor: this.resdata.Counselor,
        UserID: JSON.parse(sessionStorage.getItem("xinxi")).UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.pddialogVisible = false;
          this.FiveStar1 = 0;
          this.FiveStar2 = 0;
          this.FiveStar3 = 0;
          this.FiveStar4 = 0;
          this.FiveStar5 = 0;
          this.ServiceImpress = [];
          this.Suggestion = '';
          this.resdata = '';
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    aaad(val,type) {
      if (type == 1) {
        this.resdata = val;
        this.pddialogVisible = true;
        this.FiveStar1 = 0;
        this.FiveStar2 = 0;
        this.FiveStar3 = 0;
        this.FiveStar4 = 0;
        this.FiveStar5 = 0;
        this.ServiceImpress = [];
        this.Suggestion = '';
      } else {
        this.$Http_Post('ConsultAppoint/GetComment', {ConsultAnswerKey: val.AppointmentID,UserID: JSON.parse(sessionStorage.getItem("xinxi")).UserID,Counselor: val.Counselor}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.FiveStar1 = res.Data.fiveStar1;
            this.FiveStar2 = res.Data.fiveStar2;
            this.FiveStar3 = res.Data.fiveStar3;
            this.FiveStar4 = res.Data.fiveStar4;
            this.FiveStar5 = res.Data.fiveStar5;
            this.Suggestion = res.Data.suggestion;
            this.ServiceImpress = eval('(' + res.Data.serviceImpress + ')').map(String);
            this.pddialogVisible = true;
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    Visited(e) {
      this.$refs.childdetail.Detail(e,0);
    },
    handleCommand(command, a) { 
    },
    dialogVisibles(val) {
      if (this.wppvalue2) {
        if (this.wppvalue) {
          this.$confirm('确定预约吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            var from = {
              TeacherUserID: this.wppvalue2, //咨询师ID
              StudentUserID: this.wppvalue, //学生ID
              ConsultSchID: val.ConsultSchID, //咨询师排版编号
              SchedulYM: val.SchedulYM, //排版学期ID
              ConsultType: '1',//咨询方式
              SchedulingDate: '',//排版日期
            };
            this.$Http_Post('ConsultSubscribe/AddAdminAppointment', {from: from}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.Global.request_successful(res.Message);
                this.consulting(this.wppvalue2, '', this.wppvalue);
              } else {
                this.Global.request_failure(res.Message);
              }
            });
          })
        } else {
          alert('请选择学生');
        }
      } else {
        alert('请选择咨询师');
      }
    },
    hxsi(row,type){
      if(type == 1){
        this.WPPdble = true;
        this.ConsultRecord = row.ConsultRecord;
      }else{
        this.WPPdble = true;
        this.ConsultRecord = row.CrisisRecord;
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.wpploading = true;
        setTimeout(() => {
          this.wpploading = false;
          this.$Http_Post('ConsultSubscribe/GetAppointmentNameList', {Query: query}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.wppoptions = res.Data;
            }
          });
        }, 100);
      } else {
        this.options = [];
      }
    },
    remoteMethod2(query) {
      if (query !== '') {
        this.wpploading2 = true;
        setTimeout(() => {
          this.wpploading2 = false;
          var form = { Name: query };
          this.$Http_Post('ConsultSubscribe/ShowZiXunShi', { from: form }).then(
            (res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.wppoptions2 = res.Data;
              }
            }
          );
        }, 100);
      } else {
        this.options = [];
      }
    },
    bgcs(val) {
      if (this.wppvalue2) {
        if (this.wppvalue) {
          this.consulting(this.wppvalue2, '', this.wppvalue);
        } else {
          alert('请选择学生');
        }
      } else {
        alert('请选择咨询师');
      }
    },
    consulting(val, time, laiUserID) {
      var from = { UserID: val, Dates: time, laiUserID: laiUserID };
      this.$Http_Post('ConsultSubscribe/GetConsultationAppointment', {
        from: from,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.paiban = res.Data;
        }
      });
    },
    filterChange(filterObj) {
      this.filterObj = filterObj;
      this.pageIndex = 0;
      this.Init();
    },
    weilaifang(val) {
      this.$Http_Post('ConsultAppoint/UpdateAppointmentSatus', {State: '4',UserID: val.UserID,AppointmentID: val.AppointmentID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.Init();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    Gourl(a) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      });
      window.open(routeData.href, '_blank');
    },
    handleSizeChange(val) { },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.Init(val);
    },
    wexport() {
      this.$Http_Post('ConsultSubscribe/ExportFile', {AppointmentID: this.from.AppointmentID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.replace(res.Data);
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    WPPdialogClose() {
      this.$confirm('确认关闭？')
      .then((_) => {
        this.WPPdialogVisible = false;
      })
      .catch((_) => { });
    },
    Fillin(row, event) {
      this.from = {
            AnswerName1: '',
            AnswerName2: '',
            AnswerName3: '',
            AnswerName4: '',
            AnswerName5: '',
            AnswerName6: '',
            AnswerName7: '',
            AnswerName8: '',
            AnswerName8Detail: '',
            AnswerName9: '',
            AnswerName9Detail: '',
            AnswerName10: '',
            AnswerName10Detail: '',
            AnswerName11: '',
            AnswerName11Detail: '',
            AnswerName12: '',
            AnswerName13: '',
            AnswerName13A: '',
            AnswerName13A_1: '',
            AnswerName13A_2: '',
            AnswerName13A_3: '',
            AnswerName13A_4: '',
            AnswerName13A_5: '',
            AnswerName13A_6: '',
            AnswerName13A_7: '',
            AnswerName13Detail: '',
            AnswerName13_1: [],
            AnswerName14Detail: '',
            AnswerName14: '',
            AnswerName15: '',
            AnswerName15Detail: '',
            AnswerName16: '',
            AnswerName16Detail: '',
            AnswerName17: '',
            AnswerName17Detail: '',
            AnswerName18: '',
            AnswerName18Detail: '',
            AnswerName19: '',
            AnswerName20: '',
            AnswerName21: '',
            AnswerName22: '',
            AnswerName23: '',
            AnswerName24: '',
            AnswerName25: '',
            AnswerName26: '',
            AnswerName27: '',
            AnswerName28: '',
            AnswerName29: '',
            // AnswerName30: '',
            // AnswerName31: '',
            // AnswerName32: '',
            AnswerName33: '',
            AnswerName34: '',
            // AnswerName35: '',
            // AnswerName36: '',
            AnswerName37: '',
            AnswerName38: '',
            AnswerName38Detail: '',
            AnswerName39: '',
            AnswerName39Detail: '',
            AnswerName40: '',
            AnswerName40Detail: '',
            AnswerName41: '',
            AnswerName41Detail: '',
            AnswerName42: '',
            AnswerName42Detail: '',
            AnswerName43: '',
            AnswerName43Detail: '',
            AnswerName44: '',
            AnswerName44Detail: '',
            AnswerName45: '',
            AnswerName45Detail: '',
            AnswerName46: '',
            AnswerName46Detail: '',
            AnswerName47: '',
            AnswerName48: '',
            AnswerName49: '',
            AnswerName50: '',
            AnswerName51: '',
            AnswerName52: '',
            AnswerName53: '',
            AnswerName54: '',
            AnswerName55: '',
            AnswerName56: '',
            AnswerName57: '',
            AnswerName58: '',
            AnswerName59: '',
            AnswerName60: '',
            AnswerName61: [],
            AnswerName61A: '',
            AnswerName62: '',
            AnswerName63: '',
            AnswerName64: [],
            AnswerName64Detail: '',
            AnswerName65: '',
            AnswerName66: '',
            AnswerName67: '',
            AnswerName68: '',
            AnswerName69: '',
            AnswerName70: '',//家族史
            AnswerName71: '',//
            AnswerName72: '',//
            AnswerName73: '',//
            AnswerName74: '',//
            AnswerName75: '',//
            AnswerName76: '',//
            AnswerName77: '',//
            AnswerName78: '',//
            AnswerName79: '',//
            AnswerName80: '',//
            AppointmentID: '',
            AppointmentKey: '',
            UserID: '',
            Counselor: '',
            Riqi: '',
            Status: '5',
          }
      this.pdtj = 1;
      this.from.UserID = event.UserID;
      this.from.Counselor = event.Counselor;
      this.wonedata = event;
      this.WPPdialogVisible = true;
      this.from.AppointmentID = event.AppointmentID;
      this.from.AppointmentKey = event.AppointmentID;
      this.$Http_Post('ConsultSubscribe/GetAnswerTemp', { AppointmentKey:  this.from.AppointmentKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if(res.Data.answerResult){
            this.from = JSON.parse(res.Data.answerResult)
          }
        }else{
          this.Global.request_failure(res.Message);
        }
      });


    },
    giypj(){
      this.$Http_Post('ConsultSubscribe/CommentConsultAnswer', { ConsultAnswerKey:  this.consultanswerkey,Content:this.glypj }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.WPPdialogVisible2 = false;
        }else{
          this.Global.request_failure(res.Message);
        }
      });
    },
    wlooks(row, event) {
      this.from.AppointmentID = event.AppointmentID;
      this.wonedata = event;
      this.WPPdialogVisible2 = true;
      var xcscs = {
        AppointmentID: event.AppointmentID,
      };
      this.$Http_Post('ConsultSubscribe/FxConsultAnswer', { from: xcscs }).then((res) => {
          this.$message.closeAll();
          if (res.Code == 200 || res.Code == 0) {
            this.wonedata2 = res.Data;
            this.consultanswerkey = res.Data.consultanswerkey
          }
        }
      );
    },
    Temporary_storage(){
      this.$Http_Post('ConsultSubscribe/SaveAnswerTemp', {AppointmentKey: this.from.AppointmentKey,AnswerResult:JSON.stringify(this.from) }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loadingpd = false
          this.from = {
            AnswerName1: '',
            AnswerName2: '',
            AnswerName3: '',
            AnswerName4: '',
            AnswerName5: '',
            AnswerName6: '',
            AnswerName7: '',
            AnswerName8: '',
            AnswerName8Detail: '',
            AnswerName9: '',
            AnswerName9Detail: '',
            AnswerName10: '',
            AnswerName10Detail: '',
            AnswerName11: '',
            AnswerName11Detail: '',
            AnswerName12: '',
            AnswerName13: '',
            AnswerName13A: '',
            AnswerName13A_1: '',
            AnswerName13A_2: '',
            AnswerName13A_3: '',
            AnswerName13A_4: '',
            AnswerName13A_5: '',
            AnswerName13A_6: '',
            AnswerName13A_7: '',
            AnswerName13Detail: '',
            AnswerName13_1: [],
            AnswerName14Detail: '',
            AnswerName14: '',
            AnswerName15: '',
            AnswerName15Detail: '',
            AnswerName16: '',
            AnswerName16Detail: '',
            AnswerName17: '',
            AnswerName17Detail: '',
            AnswerName18: '',
            AnswerName18Detail: '',
            AnswerName19: '',
            AnswerName20: '',
            AnswerName21: '',
            AnswerName22: '',
            AnswerName23: '',
            AnswerName24: '',
            AnswerName25: '',
            AnswerName26: '',
            AnswerName27: '',
            AnswerName28: '',
            AnswerName29: '',
            // AnswerName30: '',
            // AnswerName31: '',
            // AnswerName32: '',
            AnswerName33: '',
            AnswerName34: '',
            // AnswerName35: '',
            // AnswerName36: '',
            AnswerName37: '',
            AnswerName38: '',
            AnswerName38Detail: '',
            AnswerName39: '',
            AnswerName39Detail: '',
            AnswerName40: '',
            AnswerName40Detail: '',
            AnswerName41: '',
            AnswerName41Detail: '',
            AnswerName42: '',
            AnswerName42Detail: '',
            AnswerName43: '',
            AnswerName43Detail: '',
            AnswerName44: '',
            AnswerName44Detail: '',
            AnswerName45: '',
            AnswerName45Detail: '',
            AnswerName46: '',
            AnswerName46Detail: '',
            AnswerName47: '',
            AnswerName48: '',
            AnswerName49: '',
            AnswerName50: '',
            AnswerName51: '',
            AnswerName52: '',
            AnswerName53: '',
            AnswerName54: '',
            AnswerName55: '',
            AnswerName56: '',
            AnswerName57: '',
            AnswerName58: '',
            AnswerName59: '',
            AnswerName60: '',
            AnswerName61: [],
            AnswerName61A: '',
            AnswerName62: '',
            AnswerName63: '',
            AnswerName64: [],
            AnswerName64Detail: '',
            AnswerName65: '',
            AnswerName66: '',
            AnswerName67: '',
            AnswerName68: '',
            AnswerName69: '',
            AnswerName70: '',//家族史
            AnswerName71: '',//
            AnswerName72: '',//
            AnswerName73: '',//
            AnswerName74: '',//
            AnswerName75: '',//
            AnswerName76: '',//
            AnswerName77: '',//
            AnswerName78: '',//
            AnswerName79: '',//
            AnswerName80: '',//
            AppointmentID: '',
            AppointmentKey: '',
            UserID: '',
            Counselor: '',
            Riqi: '',
            Status: '5',
          }
          this.WPPdialogVisible2 = false;
          this.WPPdialogVisible = false;
          this.Global.request_successful(res.Message);
          this.Init();
        } else {
          this.WPPdialogVisible2 = false;
          this.WPPdialogVisible = false;
          this.Global.request_failure(res.Message);
        }
      });
    },
    dialogV() {

      
      if(this.pdtj == 1){
        if (this.from.Status == "4") {
        this.$confirm('保存后数据无法修改，您能确定保存吗 ?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
            this.loadingpd = true

            this.$Http_Post('ConsultSubscribe/AddConsultAnswer', {from: this.from}).then((res) => {
              this.$message.closeAll();
              if (res.Code == 200 || res.Code == 0) {
                this.loadingpd = false
                this.from = {
                  AnswerName1: '',
                  AnswerName2: '',
                  AnswerName3: '',
                  AnswerName4: '',
                  AnswerName5: '',
                  AnswerName6: '',
                  AnswerName7: '',
                  AnswerName8: '',
                  AnswerName8Detail: '',
                  AnswerName9: '',
                  AnswerName9Detail: '',
                  AnswerName10: '',
                  AnswerName10Detail: '',
                  AnswerName11: '',
                  AnswerName11Detail: '',
                  AnswerName12: '',
                  AnswerName13: '',
                  AnswerName13A: '',
                  AnswerName13A_1: '',
                  AnswerName13A_2: '',
                  AnswerName13A_3: '',
                  AnswerName13A_4: '',
                  AnswerName13A_5: '',
                  AnswerName13A_6: '',
                  AnswerName13A_7: '',
                  AnswerName13Detail: '',
                  AnswerName13_1: [],
                  AnswerName14Detail: '',
                  AnswerName14: '',
                  AnswerName15: '',
                  AnswerName15Detail: '',
                  AnswerName16: '',
                  AnswerName16Detail: '',
                  AnswerName17: '',
                  AnswerName17Detail: '',
                  AnswerName18: '',
                  AnswerName18Detail: '',
                  AnswerName19: '',
                  AnswerName20: '',
                  AnswerName21: '',
                  AnswerName22: '',
                  AnswerName23: '',
                  AnswerName24: '',
                  AnswerName25: '',
                  AnswerName26: '',
                  AnswerName27: '',
                  AnswerName28: '',
                  AnswerName29: '',
                  // AnswerName30: '',
                  // AnswerName31: '',
                  // AnswerName32: '',
                  AnswerName33: '',
                  AnswerName34: '',
                  // AnswerName35: '',
                  // AnswerName36: '',
                  AnswerName37: '',
                  AnswerName38: '',
                  AnswerName38Detail: '',
                  AnswerName39: '',
                  AnswerName39Detail: '',
                  AnswerName40: '',
                  AnswerName40Detail: '',
                  AnswerName41: '',
                  AnswerName41Detail: '',
                  AnswerName42: '',
                  AnswerName42Detail: '',
                  AnswerName43: '',
                  AnswerName43Detail: '',
                  AnswerName44: '',
                  AnswerName44Detail: '',
                  AnswerName45: '',
                  AnswerName45Detail: '',
                  AnswerName46: '',
                  AnswerName46Detail: '',
                  AnswerName47: '',
                  AnswerName48: '',
                  AnswerName49: '',
                  AnswerName50: '',
                  AnswerName51: '',
                  AnswerName52: '',
                  AnswerName53: '',
                  AnswerName54: '',
                  AnswerName55: '',
                  AnswerName56: '',
                  AnswerName57: '',
                  AnswerName58: '',
                  AnswerName59: '',
                  AnswerName60: '',
                  AnswerName61: [],
                  AnswerName61A: '',
                  AnswerName62: '',
                  AnswerName63: '',
                  AnswerName64: [],
                  AnswerName64Detail: '',
                  AnswerName65: '',
                  AnswerName66: '',
                  AnswerName67: '',
                  AnswerName68: '',
                  AnswerName69: '',
                  AnswerName70: '',//家族史
                  AnswerName71: '',//
                  AnswerName72: '',//
                  AnswerName73: '',//
                  AnswerName74: '',//
                  AnswerName75: '',//
                  AnswerName76: '',//
                  AnswerName77: '',//
                  AnswerName78: '',//
                  AnswerName79: '',//
                  AnswerName80: '',//
                  AppointmentID: '',
                  AppointmentKey: '',
                  UserID: '',
                  Counselor: '',
                  Riqi: '',
                  Status: '5',
                }
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_successful(res.Message);
                this.Init();
              } else {
                this.loadingpd = false
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_failure(res.Message);
              }
            });
          })
      } else {
        
        if (!this.from.AnswerName1) {
          this.Global.request_failure("请选择保密原则告知和解释（书面和口头）")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName2) {
          this.Global.request_failure("请选择知情同意讨论（书面和口头）")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName8) {
          this.Global.request_failure("请选择重大丧失")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName9) {
          this.Global.request_failure("请选择暴力侵害史")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName10) {
          this.Global.request_failure("请选择性侵害史")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName11) {
          this.Global.request_failure("请选择被忽视史")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName13) {
          this.Global.request_failure("请选择精神病史")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName14) {
          this.Global.request_failure("请选择自杀自伤史")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName16) {
          this.Global.request_failure("请选择暴力攻击倾向史")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName17) {
          this.Global.request_failure("请选择酒精滥用史")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName18) {
          this.Global.request_failure("请选择物质滥用史")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName13A) {
          this.Global.request_failure("请选择家族史")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName20) {
          this.Global.request_failure("请选择风险评估及心理干预提示")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName21) {
          this.Global.request_failure("请选择保护因素评估──咨询/求助动机")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName22) {
          this.Global.request_failure("请选择保护因素评估──家庭支持")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName23) {
          this.Global.request_failure("请选择保护因素评估──社会支持")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName24) {
          this.Global.request_failure("请选择保护因素评估──问题解决能力")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName25) {
          this.Global.request_failure("请选择保护因素评估──活下去的希望")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName26) {
          this.Global.request_failure("请选择保护因素评估──积极的宗教信仰")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName27) {
          this.Global.request_failure("请选择保护因素评估──不想让有些/某个重要人物失望")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName29) {
          this.Global.request_failure("风险评估及心理干预提示!")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName70) {
          this.Global.request_failure("请输入咨询过程记录!")
          this.loadingpd = false
          return false
        }

        
        // if (!this.from.AnswerName30) {
        //   this.Global.request_failure("请选择保护因素评估──咨询/求助动机")
        //   this.loadingpd = false
        //   return false
        // }
        // if (!this.from.AnswerName31) {
        //   this.Global.request_failure("请选择保护因素评估──社会支持")
        //   this.loadingpd = false
        //   return false
        // }
        // if (!this.from.AnswerName32) {
        //   this.Global.request_failure("请选择保护因素评估──问题解决能力")
        //   this.loadingpd = false
        //   return false
        // }
        if (!this.from.AnswerName33) {
          this.Global.request_failure("请选择保护因素评估──自知力")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName34) {
          this.Global.request_failure("请选择保护因素评估──自制力")
          this.loadingpd = false
          return false
        }
        // if (!this.from.AnswerName35) {
        //   this.Global.request_failure("请选择保护因素评估──积极的宗教信仰")
        //   this.loadingpd = false
        //   return false
        // }
        if (!this.from.AnswerName37) {
          this.Global.request_failure("请选择自我照料危机")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName38) {
          this.Global.request_failure("请选择焦虑表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName39) {
          this.Global.request_failure("请选择注意力缺陷/多动表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName40) {
          this.Global.request_failure("请选择抑郁/低落心境表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName41) {
          this.Global.request_failure("请选择饮食不规律表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName42) {
          this.Global.request_failure("请选择躁狂/轻度躁狂表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName43) {
          this.Global.request_failure("请选择精神病性表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName44) {
          this.Global.request_failure("请选择自伤倾向表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName45) {
          this.Global.request_failure("请选择睡眠问题表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName46) {
          this.Global.request_failure("请选择物质滥用史表现与/或症状")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName48) {
          this.Global.request_failure("请选择社会功能")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName49) {
          this.Global.request_failure("请选择工作状况")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName50) {
          this.Global.request_failure("请选择家庭支持")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName51) {
          this.Global.request_failure("请选择社会支持")
          this.loadingpd = false
          return false
        }

        if (!this.from.AnswerName66) {
          this.Global.request_failure("请选择是否布置家庭作业")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName67) {
          this.Global.request_failure("请选择改善状况情绪")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName68) {
          this.Global.request_failure("请选择改善状况认知")
          this.loadingpd = false
          return false
        }
        if (!this.from.AnswerName69) {
          this.Global.request_failure("请选择改善状况行为")
          this.loadingpd = false
          return false
        }

        this.$confirm('保存后数据无法修改，您能确定保存吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
            this.loadingpd = true
            this.$Http_Post('ConsultSubscribe/AddConsultAnswer', {
              from: this.from,
            }).then((res) => {
              this.$message.closeAll();
              if (res.Code == 200 || res.Code == 0) {
                this.loadingpd = false
                this.from = {
                  AnswerName1: '',
                  AnswerName2: '',
                  AnswerName3: '',
                  AnswerName4: '',
                  AnswerName5: '',
                  AnswerName6: '',
                  AnswerName7: '',
                  AnswerName8: '',
                  AnswerName8Detail: '',
                  AnswerName9: '',
                  AnswerName9Detail: '',
                  AnswerName10: '',
                  AnswerName10Detail: '',
                  AnswerName11: '',
                  AnswerName11Detail: '',
                  AnswerName12: '',
                  AnswerName13: '',
                  AnswerName13A: '',
                  AnswerName13A_1: '',
                  AnswerName13A_2: '',
                  AnswerName13A_3: '',
                  AnswerName13A_4: '',
                  AnswerName13A_5: '',
                  AnswerName13A_6: '',
                  AnswerName13A_7: '',
                  AnswerName13Detail: '',
                  AnswerName13_1: [],
                  AnswerName14Detail: '',
                  AnswerName14: '',
                  AnswerName15: '',
                  AnswerName15Detail: '',
                  AnswerName16: '',
                  AnswerName16Detail: '',
                  AnswerName17: '',
                  AnswerName17Detail: '',
                  AnswerName18: '',
                  AnswerName18Detail: '',
                  AnswerName19: '',
                  AnswerName20: '',
                  AnswerName21: '',
                  AnswerName22: '',
                  AnswerName23: '',
                  AnswerName24: '',
                  AnswerName25: '',
                  AnswerName26: '',
                  AnswerName27: '',
                  AnswerName28: '',
                  AnswerName29: '',
                  // AnswerName30: '',
                  // AnswerName31: '',
                  // AnswerName32: '',
                  AnswerName33: '',
                  AnswerName34: '',
                  // AnswerName35: '',
                  // AnswerName36: '',
                  AnswerName37: '',
                  AnswerName38: '',
                  AnswerName38Detail: '',
                  AnswerName39: '',
                  AnswerName39Detail: '',
                  AnswerName40: '',
                  AnswerName40Detail: '',
                  AnswerName41: '',
                  AnswerName41Detail: '',
                  AnswerName42: '',
                  AnswerName42Detail: '',
                  AnswerName43: '',
                  AnswerName43Detail: '',
                  AnswerName44: '',
                  AnswerName44Detail: '',
                  AnswerName45: '',
                  AnswerName45Detail: '',
                  AnswerName46: '',
                  AnswerName46Detail: '',
                  AnswerName47: '',
                  AnswerName48: '',
                  AnswerName49: '',
                  AnswerName50: '',
                  AnswerName51: '',
                  AnswerName52: '',
                  AnswerName53: '',
                  AnswerName54: '',
                  AnswerName55: '',
                  AnswerName56: '',
                  AnswerName57: '',
                  AnswerName58: '',
                  AnswerName59: '',
                  AnswerName60: '',
                  AnswerName61: [],
                  AnswerName61A: '',
                  AnswerName62: '',
                  AnswerName63: '',
                  AnswerName64: [],
                  AnswerName64Detail: '',
                  AnswerName65: '',
                  AnswerName66: '',
                  AnswerName67: '',
                  AnswerName68: '',
                  AnswerName69: '',
                  AnswerName70: '',//家族史
                  AnswerName71: '',//
                  AnswerName72: '',//
                  AnswerName73: '',//
                  AnswerName74: '',//
                  AnswerName75: '',//
                  AnswerName76: '',//
                  AnswerName77: '',//
                  AnswerName78: '',//
                  AnswerName79: '',//
                  AnswerName80: '',//
                  AppointmentID: '',
                  AppointmentKey: '',
                  UserID: '',
                  Counselor: '',
                  Riqi: '',
                  Status: '5',
                }
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_successful(res.Message);
                this.Init();
              } else {
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_failure(res.Message);
              }
            });
          })
          .catch(() => { });
        }
      }else{
        if (this.from.Status == "4") {
        this.$confirm('保存后数据无法修改，您能确定保存吗 ?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
            this.$Http_Post('ConsultSubscribe/AddConsultAnswer', {from: this.from}).then((res) => {
              this.$message.closeAll();
              if (res.Code == 200 || res.Code == 0) {
                this.loadingpd = false
                this.from = {
                  AnswerName1: '',
                  AnswerName2: '',
                  AnswerName3: '',
                  AnswerName4: '',
                  AnswerName5: '',
                  AnswerName6: '',
                  AnswerName7: '',
                  AnswerName8: '',
                  AnswerName8Detail: '',
                  AnswerName9: '',
                  AnswerName9Detail: '',
                  AnswerName10: '',
                  AnswerName10Detail: '',
                  AnswerName11: '',
                  AnswerName11Detail: '',
                  AnswerName12: '',
                  AnswerName13: '',
                  AnswerName13A: '',
                  AnswerName13A_1: '',
                  AnswerName13A_2: '',
                  AnswerName13A_3: '',
                  AnswerName13A_4: '',
                  AnswerName13A_5: '',
                  AnswerName13A_6: '',
                  AnswerName13A_7: '',
                  AnswerName13Detail: '',
                  AnswerName13_1: [],
                  AnswerName14Detail: '',
                  AnswerName14: '',
                  AnswerName15: '',
                  AnswerName15Detail: '',
                  AnswerName16: '',
                  AnswerName16Detail: '',
                  AnswerName17: '',
                  AnswerName17Detail: '',
                  AnswerName18: '',
                  AnswerName18Detail: '',
                  AnswerName19: '',
                  AnswerName20: '',
                  AnswerName21: '',
                  AnswerName22: '',
                  AnswerName23: '',
                  AnswerName24: '',
                  AnswerName25: '',
                  AnswerName26: '',
                  AnswerName27: '',
                  AnswerName28: '',
                  AnswerName29: '',
                  // AnswerName30: '',
                  // AnswerName31: '',
                  // AnswerName32: '',
                  AnswerName33: '',
                  AnswerName34: '',
                  // AnswerName35: '',
                  // AnswerName36: '',
                  AnswerName37: '',
                  AnswerName38: '',
                  AnswerName38Detail: '',
                  AnswerName39: '',
                  AnswerName39Detail: '',
                  AnswerName40: '',
                  AnswerName40Detail: '',
                  AnswerName41: '',
                  AnswerName41Detail: '',
                  AnswerName42: '',
                  AnswerName42Detail: '',
                  AnswerName43: '',
                  AnswerName43Detail: '',
                  AnswerName44: '',
                  AnswerName44Detail: '',
                  AnswerName45: '',
                  AnswerName45Detail: '',
                  AnswerName46: '',
                  AnswerName46Detail: '',
                  AnswerName47: '',
                  AnswerName48: '',
                  AnswerName49: '',
                  AnswerName50: '',
                  AnswerName51: '',
                  AnswerName52: '',
                  AnswerName53: '',
                  AnswerName54: '',
                  AnswerName55: '',
                  AnswerName56: '',
                  AnswerName57: '',
                  AnswerName58: '',
                  AnswerName59: '',
                  AnswerName60: '',
                  AnswerName61: [],
                  AnswerName61A: '',
                  AnswerName62: '',
                  AnswerName63: '',
                  AnswerName64: [],
                  AnswerName64Detail: '',
                  AnswerName65: '',
                  AnswerName66: '',
                  AnswerName67: '',
                  AnswerName68: '',
                  AnswerName69: '',
                  AnswerName70: '',//家族史
                  AnswerName71: '',//
                  AnswerName72: '',//
                  AnswerName73: '',//
                  AnswerName74: '',//
                  AnswerName75: '',//
                  AnswerName76: '',//
                  AnswerName77: '',//
                  AnswerName78: '',//
                  AnswerName79: '',//
                  AnswerName80: '',//
                  AppointmentID: '',
                  AppointmentKey: '',
                  UserID: '',
                  Counselor: '',
                  Riqi: '',
                  Status: '5',
                }
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_successful(res.Message);
                this.Init();
              } else {
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_failure(res.Message);
              }
            });
          })
      } else {
        if (!this.from.AnswerName1) {
          this.Global.request_failure("请选择保密原则告知和解释（书面和口头）")
          return false
        }
        if (!this.from.AnswerName2) {
          this.Global.request_failure("请选择知情同意讨论（书面和口头）")
          return false
        }
        if (!this.from.AnswerName8) {
          this.Global.request_failure("请选择重大丧失")
          return false
        }
        if (!this.from.AnswerName9) {
          this.Global.request_failure("请选择暴力侵害史")
          return false
        }
        if (!this.from.AnswerName10) {
          this.Global.request_failure("请选择性侵害史")
          return false
        }
        if (!this.from.AnswerName11) {
          this.Global.request_failure("请选择被忽视史")
          return false
        }
        if (!this.from.AnswerName13) {
          this.Global.request_failure("请选择精神病史")
          return false
        }
        if (!this.from.AnswerName14) {
          this.Global.request_failure("请选择自杀自伤史")
          return false
        }
        if (!this.from.AnswerName16) {
          this.Global.request_failure("请选择暴力攻击倾向史")
          return false
        }
        if (!this.from.AnswerName17) {
          this.Global.request_failure("请选择酒精滥用史")
          return false
        }
        if (!this.from.AnswerName18) {
          this.Global.request_failure("请选择物质滥用史")
          return false
        }
        if (!this.from.AnswerName13A) {
          this.Global.request_failure("请选择家族史")
          return false
        }
        if (!this.from.AnswerName20) {
          this.Global.request_failure("请选择风险评估及心理干预提示")
          return false
        }
        if (!this.from.AnswerName21) {
          this.Global.request_failure("请选择保护因素评估──咨询/求助动机")
          return false
        }
        if (!this.from.AnswerName22) {
          this.Global.request_failure("请选择保护因素评估──家庭支持")
          return false
        }
        if (!this.from.AnswerName23) {
          this.Global.request_failure("请选择保护因素评估──社会支持")
          return false
        }
        if (!this.from.AnswerName24) {
          this.Global.request_failure("请选择保护因素评估──问题解决能力")
          return false
        }
        if (!this.from.AnswerName25) {
          this.Global.request_failure("请选择保护因素评估──活下去的希望")
          return false
        }
        if (!this.from.AnswerName26) {
          this.Global.request_failure("请选择保护因素评估──积极的宗教信仰")
          return false
        }

        if (!this.from.AnswerName27) {
          this.Global.request_failure("请选择保护因素评估──不想让有些/某个重要人物失望")
          return false
        }

        if (!this.from.AnswerName29) {
          this.Global.request_failure("风险评估及心理干预提示")
          return false
        }

        // if (!this.from.AnswerName30) {
        //   this.Global.request_failure("请选择保护因素评估──咨询/求助动机")
        //   return false
        // }

        // if (!this.from.AnswerName31) {
        //   this.Global.request_failure("请选择保护因素评估──社会支持")
        //   return false
        // }

        // if (!this.from.AnswerName32) {
        //   this.Global.request_failure("请选择保护因素评估──问题解决能力")
        //   return false
        // }
        if (!this.from.AnswerName33) {
          this.Global.request_failure("请选择保护因素评估──自知力")
          return false
        }
        if (!this.from.AnswerName34) {
          this.Global.request_failure("请选择保护因素评估──自制力")
          return false
        }
        // if (!this.from.AnswerName35) {
        //   this.Global.request_failure("请选择保护因素评估──积极的宗教信仰")
        //   return false
        // }
        if (!this.from.AnswerName37) {
          this.Global.request_failure("请选择自我照料危机")
          return false
        }
        if (!this.from.AnswerName38) {
          this.Global.request_failure("请选择焦虑表现与/或症状")
          return false
        }
        if (!this.from.AnswerName39) {
          this.Global.request_failure("请选择注意力缺陷/多动表现与/或症状")
          return false
        }
        if (!this.from.AnswerName40) {
          this.Global.request_failure("请选择抑郁/低落心境表现与/或症状")
          return false
        }
        if (!this.from.AnswerName41) {
          this.Global.request_failure("请选择饮食不规律表现与/或症状")
          return false
        }
        if (!this.from.AnswerName42) {
          this.Global.request_failure("请选择躁狂/轻度躁狂表现与/或症状")
          return false
        }
        if (!this.from.AnswerName43) {
          this.Global.request_failure("请选择精神病性表现与/或症状")
          return false
        }
        if (!this.from.AnswerName44) {
          this.Global.request_failure("请选择自伤倾向表现与/或症状")
          return false
        }
        if (!this.from.AnswerName45) {
          this.Global.request_failure("请选择睡眠问题表现与/或症状")
          return false
        }
        if (!this.from.AnswerName46) {
          this.Global.request_failure("请选择物质滥用史表现与/或症状")
          return false
        }
        if (!this.from.AnswerName48) {
          this.Global.request_failure("请选择社会功能")
          return false
        }
        if (!this.from.AnswerName49) {
          this.Global.request_failure("请选择工作状况")
          return false
        }
        if (!this.from.AnswerName50) {
          this.Global.request_failure("请选择家庭支持")
          return false
        }
        if (!this.from.AnswerName51) {
          this.Global.request_failure("请选择社会支持")
          return false
        }

        if (!this.from.AnswerName66) {
          this.Global.request_failure("请选择是否布置家庭作业")
          return false
        }
        if (!this.from.AnswerName67) {
          this.Global.request_failure("请选择改善状况情绪")
          return false
        }
        if (!this.from.AnswerName68) {
          this.Global.request_failure("请选择改善状况认知")
          return false
        }
        if (!this.from.AnswerName69) {
          this.Global.request_failure("请选择改善状况行为")
          return false
        }
        this.$confirm('保存后数据无法修改，您能确定保存吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
            this.from.ConsultAnswerKey = this.tAnswerKey;
            this.$Http_Post('ConsultSubscribe/AddConsultAnswer', {from: this.from}).then((res) => {
              this.$message.closeAll();
              if (res.Code == 200 || res.Code == 0) {
                this.loadingpd = false
                this.from = {
                  AnswerName1: '',
                  AnswerName2: '',
                  AnswerName3: '',
                  AnswerName4: '',
                  AnswerName5: '',
                  AnswerName6: '',
                  AnswerName7: '',
                  AnswerName8: '',
                  AnswerName8Detail: '',
                  AnswerName9: '',
                  AnswerName9Detail: '',
                  AnswerName10: '',
                  AnswerName10Detail: '',
                  AnswerName11: '',
                  AnswerName11Detail: '',
                  AnswerName12: '',
                  AnswerName13: '',
                  AnswerName13A: '',
                  AnswerName13A_1: '',
                  AnswerName13A_2: '',
                  AnswerName13A_3: '',
                  AnswerName13A_4: '',
                  AnswerName13A_5: '',
                  AnswerName13A_6: '',
                  AnswerName13A_7: '',
                  AnswerName13Detail: '',
                  AnswerName13_1: [],
                  AnswerName14Detail: '',
                  AnswerName14: '',
                  AnswerName15: '',
                  AnswerName15Detail: '',
                  AnswerName16: '',
                  AnswerName16Detail: '',
                  AnswerName17: '',
                  AnswerName17Detail: '',
                  AnswerName18: '',
                  AnswerName18Detail: '',
                  AnswerName19: '',
                  AnswerName20: '',
                  AnswerName21: '',
                  AnswerName22: '',
                  AnswerName23: '',
                  AnswerName24: '',
                  AnswerName25: '',
                  AnswerName26: '',
                  AnswerName27: '',
                  AnswerName28: '',
                  AnswerName29: '',
                  // AnswerName30: '',
                  // AnswerName31: '',
                  // AnswerName32: '',
                  AnswerName33: '',
                  AnswerName34: '',
                  // AnswerName35: '',
                  // AnswerName36: '',
                  AnswerName37: '',
                  AnswerName38: '',
                  AnswerName38Detail: '',
                  AnswerName39: '',
                  AnswerName39Detail: '',
                  AnswerName40: '',
                  AnswerName40Detail: '',
                  AnswerName41: '',
                  AnswerName41Detail: '',
                  AnswerName42: '',
                  AnswerName42Detail: '',
                  AnswerName43: '',
                  AnswerName43Detail: '',
                  AnswerName44: '',
                  AnswerName44Detail: '',
                  AnswerName45: '',
                  AnswerName45Detail: '',
                  AnswerName46: '',
                  AnswerName46Detail: '',
                  AnswerName47: '',
                  AnswerName48: '',
                  AnswerName49: '',
                  AnswerName50: '',
                  AnswerName51: '',
                  AnswerName52: '',
                  AnswerName53: '',
                  AnswerName54: '',
                  AnswerName55: '',
                  AnswerName56: '',
                  AnswerName57: '',
                  AnswerName58: '',
                  AnswerName59: '',
                  AnswerName60: '',
                  AnswerName61: [],
                  AnswerName61A: '',
                  AnswerName62: '',
                  AnswerName63: '',
                  AnswerName64: [],
                  AnswerName64Detail: '',
                  AnswerName65: '',
                  AnswerName66: '',
                  AnswerName67: '',
                  AnswerName68: '',
                  AnswerName69: '',
                  AnswerName70: '',//家族史
                  AnswerName71: '',//
                  AnswerName72: '',//
                  AnswerName73: '',//
                  AnswerName74: '',//
                  AnswerName75: '',//
                  AnswerName76: '',//
                  AnswerName77: '',//
                  AnswerName78: '',//
                  AnswerName79: '',//
                  AnswerName80: '',//
                  AppointmentID: '',
                  AppointmentKey: '',
                  UserID: '',
                  Counselor: '',
                  Riqi: '',
                  Status: '5',
                }
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_successful(res.Message);
                this.Init();
              } else {
                this.WPPdialogVisible2 = false;
                this.WPPdialogVisible = false;
                this.Global.request_failure(res.Message);
              }
            });
          })
          .catch(() => {

          });
        }
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then((_) => {
        done();
      })
      .catch((_) => { });
    },
    ViewDetails(row) {
      this.showViewDetails = true;
      var csccvsd = {
        AppointmentID: row.AppointmentID,
      };
      this.$Http_Post('ConsultAppoint/GetappointmentDetails', {
        from: csccvsd,
      }).then((res) => {
        this.$message.closeAll();
        if (res.Code == 200 || res.Code == 0 || res.Code == 0) {
          this.detailsdata = res.Data;
          this.ConsultPaperTime = this.detailsdata.ConsultPaperTime.slice(0,this.detailsdata.ConsultPaperTime.length - 9);
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    resetForm() {
      this.ruleForm={
        CounselorInfo: '',
        UserInfo: '',
        ConsultType: '',
        Campus: '',
        UserTime: this.padhnk?this.padhnk.split(','):this.Global.querycensus(6),
        AppointmentTime: null,
      }
      this.pageIndex = 0;
      this.Init();
    },
    onSelect() {
        this.pageIndex = 0;
        this.currentPage1 = 1;
        let _this = this;
        if (!_this.filterObj.filterTag) {
          _this.filterObj.filterTag = [];
        }
        this.$Http_Post('ConsultAppoint/GetAppointList', {
          CounselorInfo: _this.ruleForm.CounselorInfo,
          UserInfo: _this.ruleForm.UserInfo,
          ConsultType: _this.ruleForm.ConsultType,
          Campus: _this.ruleForm.Campus,
          UserTime: _this.ruleForm.UserTime,
          AppointmentTime: _this.ruleForm.AppointmentTime,
          pageIndex: _this.pageIndex,
          Lables: _this.filterObj.filterTag,
          pageSize: 10
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.AppointList = res.Data.Tplishs;
            this.Counts = Number(res.Counts);
          } else {
            this.$message.error(res.Message);
          }
        });
    },
    Init() {
      let _this = this;
      if (!_this.filterObj.filterTag) {
        _this.filterObj.filterTag = [];
      }
      this.$Http_Post('ConsultAppoint/GetAppointList', {
        CounselorInfo: _this.ruleForm.CounselorInfo,
        UserInfo: _this.ruleForm.UserInfo,
        ConsultType: _this.ruleForm.ConsultType,
        Campus: _this.ruleForm.Campus,
        UserTime: _this.ruleForm.UserTime,
        AppointmentTime: _this.ruleForm.AppointmentTime,
        pageIndex: _this.pageIndex,
        Lables: _this.filterObj.filterTag,
        pageSize: 10,
        keyNo:_this.$route.query.KeyNo?this.$route.query.KeyNo:null
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.AppointList = res.Data.Tplishs;
          _this.IsLoading = false;
          this.Counts = Number(res.Counts);
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    CheckPaperDetail(resultid) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: resultid },
      });
      window.open(routeData.href, '_blank');
    },
    SetVisitState(curItem) {
      let _this = this;
      this.$Http_Post('ConsultAppoint/SetAppointmentState', {
        AppointmentID: curItem.AppointmentID,
        Status: '5',
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({ type:'success', message:'操作成功'});
          this.Init();
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    
  },
  components:{
    Crisiscases
  }
};
</script>
<style>
.AppointmentList .el-textarea .el-input__count{background:none;bottom: -9px;right: 20px;}
.AppointmentList .xaxoaixh .el-textarea__inner{width: 80%;}
.AppointmentList .demonstration{position: absolute;top: 10px;left: 0px;font-size: 14px;color: #606266;}
.AppointmentList .el-rate{position: absolute;top: 10px;left: 80px;}
.AppointmentList  .el-rate__icon{font-size: 24px;}
.app-parent {
  height: 100%;
  overflow: auto;
}

.app-block {
  padding: 10px;
  line-height: 25px;
  background-color: #ebf5ff;
  border-radius: 5px;
  margin-bottom: 5px;
}

.app-paper-res {
  margin-left: 10px;
}

.app-paper-detail {
  color: blue;
  text-decoration: underline;
  margin-left: 10px;
  cursor: pointer;
}

.fromcss {
  padding: 30px 0px 0px 0px;
}

.AppointmentList .demo-form-inline {
  padding: 24px;
}

.el-drawer__header {
  font-size: 20px;
  margin-bottom: 1px;
}

.filein {
  background-color: rgba(239.99999999999997,
      239.99999999999997,
      239.99999999999997,
      1);
}

.filein-top {
  width: 100%;
  background-color: #fff;
}

.filein-button {
  min-height: 555px;
  margin-top: 20px;
  background-color: #fff;
}
.AppointmentList .xaxoaixh .el-dialog{background-color: #fff;}
.AppointmentList .el-dialog {
  background-color: rgba(239.99999999999997,
      239.99999999999997,
      239.99999999999997,
      1);
}

.AppointmentList .el-dialog__header {
  padding: 0px !important;
}

.AppointmentList .el-dialog__body {
  padding-top: 14px;
  background-color: #fff;
}

.filein-top .filein-top-p1 {
  font-size: 20px;
  font-weight: 700;
  padding: 16px;
}

.filein-top .filein-top-p2 {
  font-size: 18px;
  padding: 16px;
}

.filein-top .filein-top-p2 span {
  font-size: 16px;
  color: rgba(141, 141, 141, 1);
}

.filein-top i {
  display: inline-block;
  background-color: rgba(29, 154, 255, 1);
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
  padding: 1px;
  padding-left: 6px;
  padding-right: 6px;
}

.filein-top em {
  display: inline-block;
  background-color: rgba(21, 191, 109, 1);
  font-size: 14px;
  height: 26px;
  width: 60px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
}

.filein-top .el-button {
  margin-right: 16px;
  position: absolute;
  right: 50px;
  top: 30px;
}

.filein-button h2 {
  font-size: 24px;
  font-weight: 700;
  padding: 5px 16px;
}

.filein-button h3 {
  font-size: 18px;
  font-weight: 700;
  padding: 5px 16px;
  padding-left: 24px;
  padding-top: 0px;
}

.AppointmentList .el-textarea__inner {
  width: 600px;
}

.AppointmentList .el-form-item {
  margin-left: 20px;
}

.AppointmentList .el-input {
  width: 200px;
}

.AppointmentList .el-radio {
  margin-left: 0px;
}

.AppointmentList .el-form--inline .el-form-item {
  width: calc(50 - 2px);
  margin-right: 0px;
}

.AppointmentList .el-dialog__body .el-form-item__label {
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  text-indent: 24px;
  height: 100%;
}

.AppointmentList .el-dialog__body .el-form--inline .el-form-item {
  width: calc(50% - 20px);
}

.AppointmentList .el-dialog__body .hiucs {
  /* width: 714px !important; */
  width: calc(50% - 20px) !important;
}

.hiucsxxxx .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}
.hiucs .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.AppointmentList .el-dialog__body .el-textarea__inner {
  margin-left: 0px !important;
}

.AppointmentList .qxs1 .el-input__inner {
  border: none;
  border-bottom: 1px solid rgb(182, 182, 182);
  border-radius: 0px;
}

.AppointmentList .bagtit .el-form-item {
  border: none !important;
}

.AppointmentList .el-dialog__body .bvds {
  width: calc(50% - 40px) !important;
}

.hiucs2 .el-form-item__label {
  height: 106px !important;
  line-height: 106px;
}

.AppointmentList .el-dialog__body .svccsc {
  width: 840px !important;
}

.svccsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.AppointmentList .el-dialog__body .svcsscsc {
  width: 860px !important;
}

.svcsscsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.AppointmentList .el-dialog__body .el-form-item__content span {
  margin-left: 5px;
}

.AppointmentList .boxs {
  background-color: #fff;
  margin-bottom: 15px;
}

.AppointmentList .boxs button {
  float: right;
  margin-right: 20px;
}

.AppointmentList .boxs2 {
  background-color: #fff;
  height: 620px;
}

.AppointmentList .block {
  float: right;
}

.el-drawer__body tbody td {
  border: none;
}

.AppointmentList .el-descriptions-item__label {
  color: rgba(40, 40, 40, 1);
  font-size: 16px;
}

.AppointmentList .el-descriptions-item__content {
  color: rgba(141, 141, 141, 1);
}

.AppointmentList .el-drawer__open .el-drawer.rtl {
  width: 40% !important;
}

#el-drawer__title {
  color: #000;
  font-weight: 700;
}

.paiban {
  margin-top: 20px;
  height: 900px;
  background-image: url(/img/img_body_bg.c95be18f.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.AppointmentList .ClientConsulting_right_ul {
  margin-left: -3px;
  width: 100%;
}

.AppointmentList .ClientConsulting_right_ul>li {
  background-color: #031924;
  float: left;
  margin-top: 10px;
  width: calc(100% / 7 - 10px);
}

.AppointmentList .ClientConsulting_right_ul>li ul {
  margin-left: 10px;
}

.AppointmentList .ClientConsulting_right_ul>li ul li {
  margin-top: 10px;
  height: 60px;
  width: 100%;
  background-color: #0a3554;
  margin-left: 4px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  color: #6ebec2;
  position: relative;
}

.AppointmentList .ClientConsulting_right_ul>li ul li p {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
  display: none;
}

.AppointmentList .ClientConsulting_right_ul>li ul li i {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
}

.AppointmentList .ClientConsulting_right_ul>li ul li i:hover span {
  display: block;
}

.AppointmentList .ClientConsulting_right_ul>li ul li i span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: rgba(11, 131, 138, 1);
  color: rgba(64, 245, 255, 1);
  position: absolute;
  top: 0px;
  left: 0px;
  display: none;
}

.AppointmentList .ClientConsulting_right_ul>li ul li:hover p {
  display: block;
}

.AppointmentList .ClientConsulting_right_top {
  margin-left: 10px;
}

.AppointmentList .ClientConsulting_right_top li {
  background-color: rgb(10 53 84);
  width: calc(100% / 7 - 10px);
  float: left;
  height: 56px;
  margin-top: 20px;
  border: 1px solid #00e6ff;
  margin-left: -1px;
  color: #6ebec2;
  text-align: center;
}

.AppointmentList .ClientConsulting_right_top li p {
  height: 20px;
  margin-top: 6px;
}

.AppointmentList .ClientConsulting_right_ul {
  margin-left: 0px;
}

.AppointmentList .el-table__column-filter-trigger i {
  color: #fff;
  font-size: 16px;
  margin-left: 10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 12px;
  margin-bottom: 20px;
}

.el-radio__inner {
  border: 1px solid #55585e;
}

.AppointmentList .el-table--enable-row-transition .el-table__body td {
  text-align: center;
}

.warning-row{background: #ffe0e4 !important;}
.warning-row111{background: #f5f5f5   !important;}

.AppointmentList .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{width: 240px;}
</style>
